import {
  DialogContent,
  Grid,
  Link,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import "../../CSS/app.min.css";
import "../../CSS/bootstrap.min.css";
import "../../CSS/custom.min.css";
import "../../CSS/mermaid.min.css";
import "../../CSS/slickDashboard.css";
import { onToggle } from "../../CommonActions/common.slice";
import image4 from "../../Images/sales.png";
import image5 from "../../Images/store.png";
import image6 from "../../Images/builders.png";
import image7BgClr from "../../Images/technician.png";
import target1 from "../../Images/target_new.png";
import {
  showLoador,
  showNotification,
} from "../../Pages/Landing/Landing.slice";
import {
  getMonthYearTarget,
  getMonthYearTargetForSales,
  getRegionListFromYearAndMonth,
  getSalesGraph,
  getSalesListFromYearAndMonthNew,
  setSalesListFromYearAndMonthNew,
  getSalesTeamInfoByDatesWithAttendanceAndArea,
  getStateRegionwiseListFromYearAndMonth,
  getZoneListFromYearAndMonth,
  getZoneStatewiseListFromYearAndMonth,
  getDistrictListFromYearAndMonth,
  setRegionListFromYearAndMonth,
  getTalukaListFromYearAndMonth,
  getSalesTeamInfoByDatesAndFlag,
  getSalesTeamWithBackgroundTrackingDataAndHistoryByDate,
} from "../../Slice/adminDashboard.slice";
import { getBeatFromSalesTeamId } from "../../Slice/beat.slice";
import {
  getCategorywiseBill,
  getPackagingType,
} from "../../Slice/billingHistory.slice";
import {
  getAdminDashboard,
  getTopProductOrderListFromYearAndMonthBillWise,
  getTopProductForAdminDashboard,
} from "../../Slice/dashboard.slice";
import { getStockStakeHolderType } from "../../Slice/stockStakeHolderType.slice";
import {
  getCategoryByPackagingType,
  getSubCategoryNew,
  getSubCategoryPackagingType,
} from "../../Slice/subCategory.slice";
import AutoComplete from "../../components/Comman/AutoComplete";
import { ButtonCompo } from "../../components/Comman/Button";
import { ConvertAmount } from "../../components/Comman/ConvertValueWithDenominator";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import { LabelCompo } from "../../components/Comman/Label";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import PaginatedDataTable from "../../components/Comman/PaginatedDataTable";
import MonthCalender from "../../components/MonthCalender";
import SearchBar from "../../components/Search";
import { getSalesTeamAnalysisColumns } from "../../tableColumns/table-columns";
import {
  cyanBlue,
  redColor,
  titleColor,
  yellowColor,
} from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import * as myConstClass from "../../config/messageconstant";
import { serverMsg } from "../../config/messageconstant";
import { apiGet } from "../../utils/api_service";
import BeatPopUp from "../DashbourdChanges/BeatPopUp";
import MonthlyBarChart from "../DashbourdChanges/MonthlyBarChart";
import NoDataFound from "../DashbourdChanges/NoDataFound";
import PieChart from "../DashbourdChanges/PieChart";
import { downloadF } from "../PDF/PDFDownload";
import CategoryPopup from "./CategoryPopup";
import HierarchyDropDownOld from "./HierarchyDropDownOld";
import SubCategoryPackagingTypePopup from "./SubCategoryPackagingTypePopup";
import ReactApexChart from "react-apexcharts";
import { getRegionNew } from "../../Slice/region.slice";
import { getStateByRegion } from "../../Slice/state.slice";
import { getZoneByState } from "../../Slice/zone.slice";
import { getDistrictByZone } from "../../Slice/district.slice";
import { getAreaByTalukaPostBodyUpdated } from "../../Slice/area.slice";
import { getTalukaByDistrictPost } from "../../Slice/taluka.slice";
import NewMultipleSelect from "../../components/Comman/NewMultipleSelect";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import DynamicTable from "../../components/Comman/RT/MaterialUIRTTable";
import {
  getGroupBySubCategory,
  getGroupWisePackagingType,
} from "../../Slice/groupProduct.slice";
import CloseIcon from "@mui/icons-material/Close";
import {
  getProductByGroupId,
  getProductByGroupIdAndPackagingId,
} from "../../Slice/product.slice";
import SubscriptionExpiryMarquee from "../../components/dynamicscreens/SubscriptionExpiryBar";
import { getCurrentDate } from "../../utils/dateFormat";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};


const TAB_CONFIG = [
  { value: "5", label: "Stale Location", flag: 1 },
  { value: "6", label: "Fake GPS Location", flag: 3 },
  { value: "7", label: "Location Service On/Off", flag: 2, showStatus: true },
];

class AnalyticalAdminDashboard extends Component {
  toggleDrawer = () => {
    this.props.onToggle();
  };
  state = {
    region: [],
    state: [],
    zone: [],
    district: [],
    taluka: [],
    area: [],
    areaIdsStore: [],
    popUpFlag: false,
    popUpFlagForSubCategory: false,
    popUpFlagForPackagingType: false,
    popUpFlagForProduct: false,
    popUpFlagCategory: false,
    beatPopupFlag: false,
    date: "",
    type: [],
    saleMonth: dayjs(),
    month: "",
    year: "",
    searchValueForProduct: "",
    searchValueForSalesTeamList: "",
    searchValueSalesTeamAnalysisList: "",
    formErrors: {},
    radioValue: [],
    lineGraphData: [],
    productList: [],
    totalOutletCount: 0,
    zero: 0,
    productiveCall: 0,
    unvisited: 0,
    totalAmount: 0,
    salesAmt: 0,
    salesListFromYearAndMonthOnSearch: false,
    dateForSalesTeamList: dayjs(),
    dateForSalesTeamAnalysis: dayjs(),
    backgroundSettingHistory: [],
    value: "0",
    valueForSalesTeamAnalysis: "5",
  };

  createData(name, code, population, size) {
    const density = population / size;
    return { name, code, population, size, density };
  }

  async componentDidMount() {
    const {
      getAdminDashboard,
      showLoador,
      showNotification,
      getCategorywiseBill,
      getPackagingType,
      getStockStakeHolderType,
      getRegionListFromYearAndMonth,
      getSalesListFromYearAndMonthNew,
      setSalesListFromYearAndMonthNew,
      getZoneListFromYearAndMonth,
      getZoneStatewiseListFromYearAndMonth,
      getStateRegionwiseListFromYearAndMonth,
      getDistrictListFromYearAndMonth,
      getMonthYearTarget,
      getSalesGraph,
      getMonthYearTargetForSales,
      dashboardData,
      getTalukaListFromYearAndMonth,
      getTopProductForAdminDashboard,
      getRegionNew,
    } = this.props;
    const { year, month, regionId } = this.state;

    if (navigator.onLine) {
      setSalesListFromYearAndMonthNew({ row: [] });

      const adminDashboard = localStorage.getItem("adminDashboard");
      const adminDashboardData = JSON.parse(adminDashboard);

      const stockStakeHolderTypeListData = localStorage.getItem(
        "stockStakeHolderTypeListData"
      );
      const stockStakeHolderTypeListLocalStorage = JSON.parse(
        stockStakeHolderTypeListData
      );

      const regionListFromYearAndMonth = localStorage.getItem(
        "regionListFromYearAndMonth"
      );
      const regionListFromYearAndMonthLocalStorage = JSON.parse(
        regionListFromYearAndMonth
      );

      const categoryWiseBillData = localStorage.getItem("categoryWiseBillData");
      const categoryWiseBillDataLocalStorage = JSON.parse(categoryWiseBillData);

      const packagingTypeData = localStorage.getItem("packagingTypeData");
      const packagingTypeDataLocalStorage = JSON.parse(packagingTypeData);

      const monthYearTargetData = localStorage.getItem("monthYearTargetData");
      const monthYearTargetDataLocalStorage = JSON.parse(monthYearTargetData);

      if (!adminDashboardData) {
        showLoador({ loador: true });
        await getAdminDashboard().then(({ data, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (data !== null && Object.keys(data).length !== 0) {
              localStorage.setItem("adminDashboard", JSON.stringify(data));
            } else {
              localStorage.setItem("adminDashboard", JSON.stringify([]));
            }
          }
        });

        showLoador({ loador: true });
        await getTopProductForAdminDashboard().then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            const topProductList = response.length !== 0 ? response : [];
            localStorage.setItem(
              "topProductList",
              JSON.stringify(topProductList)
            );
          }
        });
      }

      showLoador({ loador: true });
      await getRegionNew().then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      if (!stockStakeHolderTypeListLocalStorage) {
        showLoador({ loador: true });
        await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
          ({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              const stockStakeHolderTypeList =
                response.length !== 0 ? response : [];
              localStorage.setItem(
                "stockStakeHolderTypeListData",
                JSON.stringify(stockStakeHolderTypeList)
              );
              localStorage.setItem(
                "stockStakeHolderTypeId",
                response.length !== 0 ? response[0].id : ""
              );

              /*Comment By Tejas For Person Wise Sales Table */

              // this.setState({
              //   type: response.length !== 0 ? response[0].id.split(",") : "",
              // });

              // let dataToSend = {
              //   stockStakeHolderTypeIds: [],
              // };

              // showLoador({ loador: true });
              // getSalesListFromYearAndMonthNew({
              //   month: dayjs().format("MM"),
              //   year: dayjs().format("YYYY"),
              //   dataJson: dataToSend,
              // }).then(({ response, success }) => {
              //   showLoador({ loador: false });
              //   if (!success) {
              //     showNotification({ msg: serverMsg, severity: "error" });
              //   } else {
              //     this.setState({
              //       salesListFromYearAndMonthOnSearch: true,
              //     });
              //     const salesList = response ? response : [];
              //     localStorage.setItem(
              //       "salesListFromYearAndMonthNew",
              //       JSON.stringify(salesList)
              //     );
              //   }
              // });
            }
          }
        );
      }

      if (!regionListFromYearAndMonthLocalStorage) {
        //1
        showLoador({ loador: true });
        await getRegionListFromYearAndMonth({
          month: dayjs().format("MM"),
          year: dayjs().format("YYYY"),
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            this.setState({
              regionId: response[0].id,
            });

            showLoador({ loador: true });
            getSalesGraph({
              month: dayjs().format("MM"),
              year: dayjs().format("YYYY"),
              regionId: response.length !== 0 ? response[0].id : "",
            }).then(({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                let graphData = [];
                let monthData = [];

                response.length !== 0
                  ? response.map((responseObject) => {
                    graphData.push(responseObject.achivedAmt);
                    monthData.push(responseObject.monthString);
                  })
                  : [];
              }
            });

            // showLoador({ loador: true });
            // getZoneListFromYearAndMonth({
            //   month: dayjs().format("MM"),
            //   year: dayjs().format("YYYY"),
            //   regionId: response[0].id,
            // }).then(({ response, success }) => {
            //   showLoador({ loador: false });
            //   if (!success) {
            //     showNotification({ msg: serverMsg, severity: "error" });
            //   } else {
            //     localStorage.setItem(
            //       "zoneDetailsSalesData",
            //       response.length !== 0 ? response : []
            //     );
            //     localStorage.setItem(
            //       "zoneListFromYearAndMonthTotal",
            //       dashboardData?.zoneListFromYearAndMonthTotal
            //     );
            //   }
            // });

            //2

            // getStateRegionwiseListFromYearAndMonth({
            //   month: dayjs().format("MM"),
            //   year: dayjs().format("YYYY"),
            //   regionId: response[0].id,
            // }).then(({ response, success }) => {
            //   if (!success) {
            //     showNotification({ msg: serverMsg, severity: "error" });
            //   } else {
            //     this.setState({
            //       stateListFromYearAndMonth:
            //         response.length !== 0 ? response : [],
            //     });

            //3
            //     if (response.length !== 0) {
            //       getZoneStatewiseListFromYearAndMonth({
            //         month: dayjs().format("MM"),
            //         year: dayjs().format("YYYY"),
            //         stateId: response[0].id,
            //       }).then(({ response, success }) => {
            //         if (!success) {
            //           showNotification({ msg: serverMsg, severity: "error" });
            //         } else {
            //           getDistrictListFromYearAndMonth({
            //             month: dayjs().format("MM"),
            //             year: dayjs().format("YYYY"),
            //             zoneId: response[0].id,
            //           }).then(({ response, success }) => {
            //             if (!success) {
            //               showNotification({
            //                 msg: serverMsg,
            //                 severity: "error",
            //               });
            //             } else {
            //               getTalukaListFromYearAndMonth({
            //                 month: dayjs().format("MM"),
            //                 year: dayjs().format("YYYY"),
            //                 districtId: response[0].id,
            //               }).then(({ response, success }) => {
            //                 if (!success) {
            //                   showNotification({
            //                     msg: serverMsg,
            //                     severity: "error",
            //                   });
            //                 } else {
            //                   this.setState({
            //                     talukaDetailsDistrictWiseData:
            //                       response.length !== 0 ? response : [],
            //                   });
            //                 }
            //               });
            //             }
            //           });
            //         }
            //       });
            //     }
            //   }
            // });
          }
        });
      }

      if (!categoryWiseBillDataLocalStorage) {
        showLoador({ loador: true });
        getCategorywiseBill({
          year: dayjs().format("YYYY"),
          month: dayjs().format("MM"),
          regionId: "",
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            const categoryWiseBillList = response.length !== 0 ? response : [];
            localStorage.setItem(
              "categoryWiseBillData",
              JSON.stringify(categoryWiseBillList)
            );

            this.setState({
              categoryWiseBillData: response.length !== 0 ? response : [],
            });
          }
        });
      }

      if (!packagingTypeDataLocalStorage) {
        getPackagingType({
          year: dayjs().format("YYYY"),
          month: dayjs().format("MM"),
          regionId: "",
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            const packagingTypeDataList = response.length !== 0 ? response : [];
            localStorage.setItem(
              "packagingTypeData",
              JSON.stringify(packagingTypeDataList)
            );

            this.setState({
              packagingTypeData: response.length !== 0 ? response : [],
            });
          }
        });
      }

      if (!monthYearTargetDataLocalStorage) {
        showLoador({ loador: true });
        getMonthYearTarget().then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
            if (response.length !== 0) {
              let totalTargetNewList = [];
              let totalAchievedNewList = [];
              for (var i = 0; i < response.length; i++) {
                totalAchievedNewList.push(+response[i].achivedAmt);
                totalTargetNewList.push(+response[i].targetAmt);
              }

              let radioValue = [
                {
                  name: "Target",
                  data: totalTargetNewList,
                },
                {
                  name: "Achieved",
                  data: totalAchievedNewList,
                },
              ];

              const monthYearTargetList =
                radioValue.length !== 0 ? radioValue : [];
              localStorage.setItem(
                "monthYearTargetData",
                JSON.stringify(monthYearTargetList)
              );

              this.setState({
                radioValue: [
                  {
                    name: "Target",
                    data: totalTargetNewList,
                  },
                  {
                    name: "Achieved",
                    data: totalAchievedNewList,
                  },
                ],
              });
            }
          }
        });
      }
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  }

  handleClosesSalesTeam = () => {
    this.setState({
      beatPopupFlag: false,
    });
  };

  salesTeamHandler = (e, salesTeamId) => {
    const { getBeatFromSalesTeamId, showLoador, showNotification } = this.props;
    const { popUpFlag } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getBeatFromSalesTeamId({
        salesTeamIds: salesTeamId,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            beatPopupFlag: true,
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };
  regionWiseSalesHandler = (e, regionId) => {
    const {
      getZoneListFromYearAndMonth,
      showLoador,
      showNotification,
      getSalesGraph,
    } = this.props;
    const { month, year, saleMonth } = this.state;
    let graphData = [];
    if (navigator.onLine) {
      showLoador({ loador: true });
      getZoneListFromYearAndMonth({
        month: month !== "" ? month : saleMonth.format("MM"),
        year: year !== "" ? year : saleMonth.format("YYYY"),
        regionId: regionId,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
        }
      });
      showLoador({ loador: true });
      getSalesGraph({
        month: month !== "" ? month : saleMonth.format("MM"),
        year: year !== "" ? year : saleMonth.format("YYYY"),
        regionId: regionId,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          let graphData = [];
          let monthData = [];
          response.length !== 0
            ? response.map((responseObject) => {
              graphData.push(responseObject.achivedAmt);
              monthData.push(responseObject.monthString);
            })
            : [];
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  multiSelectHandler = (value, name) => {
    const { getSalesListFromYearAndMonthNew, showLoador, showNotification } =
      this.props;
    const { saleMonth } = this.state;

    const stockStakeHolderTypeListData = localStorage.getItem(
      "stockStakeHolderTypeListData"
    );
    const stockStakeHolderTypeListLocalStorage = JSON.parse(
      stockStakeHolderTypeListData
    );

    const isAllSelected = value.includes("all");
    const filterDataWithoutAll = value.filter((rowData) => rowData !== "all");
    const filterValue = value.filter((rowValue) => rowValue === "all");

    if (filterValue.length !== 0) {
      if (name === "type") {
        if (isAllSelected) {
          if (
            filterDataWithoutAll.length ===
            stockStakeHolderTypeListLocalStorage.length
          ) {
            this.setState({ type: [] });
          } else {
            const typeListAll = stockStakeHolderTypeListLocalStorage
              .filter((data) => data.id !== "all")
              .map((data) => data.id);

            this.setState({ type: typeListAll });

            let dataToSend = {
              stockStakeHolderTypeIds: typeListAll,
            };

            showLoador({ loador: true });
            getSalesListFromYearAndMonthNew({
              month: saleMonth.format("MM"),
              year: saleMonth.format("YYYY"),
              dataJson: dataToSend,
            }).then(({ response, success }) => {
              showLoador({ loador: false });
              if (!success) {
                showNotification({ msg: serverMsg, severity: "error" });
              } else {
                this.setState({
                  salesListFromYearAndMonthOnSearch: true,
                });
              }
            });
          }
        } else {
          this.setState({ type: filterDataWithoutAll });
        }
      }
    } else {
      if (name === "type") {
        this.setState({ type: value });

        if (value != "") {
          let dataToSend = {
            stockStakeHolderTypeIds: value,
          };
          showLoador({ loador: true });
          getSalesListFromYearAndMonthNew({
            month: saleMonth.format("MM"),
            year: saleMonth.format("YYYY"),
            dataJson: dataToSend,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              this.setState({
                salesListFromYearAndMonthOnSearch: true,
              });
            }
          });
        }
      }
    }
  };

  topProductHandler = (e, productId) => {
    const { saleMonth } = this.state;
    const { showLoador, showNotification } = this.props;
    showLoador({ loador: true });
    apiGet({
      url:
        endpoint.product +
        "/get-month-wise-bill-value-by-month-year-and-product?month=" +
        saleMonth.format("MM") +
        "&year=" +
        saleMonth.format("YYYY") +
        "&productId=" +
        productId,
    }).then(({ data, success }) => {
      showLoador({ loador: false });
      this.setState({
        productList: data.data,
      });
    });
  };

  salesHandler = (e, id) => {
    const { getMonthYearTargetForSales, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getMonthYearTargetForSales({ salesTeamId: id }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            // showNotification({ msg: serverMsg, severity: "error" });
          } else {
            let lineGraphDataNew = [];
            for (var i = 0; i < response.length; i++) {
              lineGraphDataNew.push(+response[i].achivedAmt);
            }
            this.setState({
              lineGraphData: lineGraphDataNew,
            });
          }
        }
      );
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  salesTeamGraphHandler = (e, regionId) => {
    const { getZoneListFromYearAndMonth, showLoador, showNotification } =
      this.props;
    const { month, year } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getZoneListFromYearAndMonth({
        month: month,
        year: year,
        regionId: regionId,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          // showNotification({ msg: serverMsg, severity: "error" });
        } else {
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  onChangeRadioValue = (value) => {
    if (value == "0") {
      // let zeroRadioValue = [
      //   {
      //     name: "Target",
      //     data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
      //   },
      //   {
      //     name: "Achieved",
      //     data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
      //   },
      // ];

      // localStorage.setItem("radioValue", zeroRadioValue);
      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
          },
        ],
      });
    } else if (value == "1") {
      // let oneRadioValue = [
      //   {
      //     name: "Target",
      //     data: [50, 60, 57, 56, 61, 58, 63, 60, 66],
      //   },
      //   {
      //     name: "Achieved",
      //     data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
      //   },
      // ];

      // localStorage.setItem("radioValue", oneRadioValue);
      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [50, 60, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
          },
        ],
      });
    } else if (value == "2") {
      // let secondRadioValue = [
      //   {
      //     name: "Target",
      //     data: [80, 70, 57, 56, 61, 58, 63, 60, 66],
      //   },
      //   {
      //     name: "Achieved",
      //     data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
      //   },
      // ];

      // localStorage.setItem("radioValue", secondRadioValue);

      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [80, 70, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
          },
        ],
      });
    } else if (value == "3") {
      // let thirdRadioValue =  [
      //   {
      //     name: "Target",
      //     data: [10, 20, 57, 56, 61, 58, 63, 60, 66],
      //   },
      //   {
      //     name: "Achieved",
      //     data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
      //   },
      // ];

      // localStorage.setItem("radioValue", thirdRadioValue);

      this.setState({
        radioValue: [
          {
            name: "Target",
            data: [10, 20, 57, 56, 61, 58, 63, 60, 66],
          },
          {
            name: "Achieved",
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
          },
        ],
      });
    }
  };

  onDateChange = (date, name) => {
    this.setState({
      month: date.format("MM"),
      year: date.format("YYYY"),
      saleMonth: date,
    });

    const {
      getRegionListFromYearAndMonth,
      getTopProductOrderListFromYearAndMonthBillWise,
      getSalesListFromYearAndMonthNew,
      showLoador,
      showNotification,
    } = this.props;
    const { type } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getRegionListFromYearAndMonth({
        month: date.format("MM"),
        year: date.format("YYYY"),
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });

      showLoador({ loador: true });
      getTopProductOrderListFromYearAndMonthBillWise({
        month: date.format("MM"),
        year: date.format("YYYY"),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          const topProductList = response.length !== 0 ? response : [];
          localStorage.setItem(
            "topProductList",
            JSON.stringify(topProductList)
          );
        }
      });

      let dataToSend = {
        stockStakeHolderTypeIds: type,
      };

      showLoador({ loador: true });
      getSalesListFromYearAndMonthNew({
        month: date.format("MM"),
        year: date.format("YYYY"),
        dataJson: dataToSend,
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            salesListFromYearAndMonthOnSearch: true,
          });
        }
      });
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  columns = [
    {
      name: "index",
      title: "Sr.No",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "center",
    },

    {
      name: "name",
      title: " Product Name",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "right",
    },
    {
      name: "code",
      title: "Product Code",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "left",
    },
    {
      name: "actualSale",
      title: "Acheived",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "right",
    },
    {
      name: "contribution",
      title: "% Contribution",
      positionCenter: false,
      showInscreen: true,
      alignCenter: "right",
    },
  ];
  graphList = [{ x: 1, y: 64 }];
  onChangeMonthOrYear = (data, name) => {
    this.setState({
      [name]: data,
    });
  };

  onClickLineChart = (data) => { };

  onSearch = (searchData) => {
    const { dashboardData, setRegionListFromYearAndMonth } = this.props;
    const { regionListFromYearAndMonthData } = this.state;
    if (searchData != "" || searchData != undefined) {
      this.setState({
        searchValue: searchData,
      });
      const list = dashboardData.regionListFromYearAndMonth.filter(
        (currentRow) => {
          let isValid = false;
          if (
            currentRow["name"] &&
            currentRow["name"]
              .toString()
              .toLowerCase()
              .includes(searchData.toLowerCase())
          ) {
            isValid = true;
            return true;
          }
          return isValid;
        }
      );
      this.setState({
        regionListFromYearAndMonthData: list,
      });
    } else {
      this.setState({
        searchValue: "",
      });
      this.setState({
        regionListFromYearAndMonthData:
          dashboardData.regionListFromYearAndMonth,
      });
    }
  };

  onSearchForTopPerformingProducts = (searchData) => {
    const { dashboardDetails } = this.props;
    const { productList } = this.state;
    if (searchData != "" || searchData != undefined) {
      this.setState({
        searchValueForProduct: searchData,
      });
      const list = dashboardDetails?.dashboardDataForProduct.filter(
        (currentRow) => {
          let isValid = false;
          if (
            (currentRow["name"] &&
              currentRow["name"]
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase())) ||
            (currentRow["code"] &&
              currentRow["code"]
                .toString()
                .toLowerCase()
                .includes(searchData.toLowerCase()))
          ) {
            isValid = true;
            return true;
          }
          return isValid;
        }
      );
      this.setState({
        dashboardDataForProduct: list,
      });
    } else {
      this.setState({
        searchValueForProduct: "",
      });
      this.setState({
        productList: dashboardDetails?.dashboardDataForProduct,
      });
    }
  };
  handleCloses = () => {
    this.setState({
      popUpFlag: false,
    });
  };
  handleClose = () => {
    this.setState({
      popUpFlagForSubCategory: false,
    });
  };

  handleCloseForPackagingType = () => {
    this.setState({
      popUpFlagForPackagingType: false,
    });
  };

  handleCloseForProduct = () => {
    this.setState({
      popUpFlagForProduct: false,
    });
  };
  handleClosesCategory = () => {
    this.setState({
      popUpFlagCategory: false,
    });
  };
  rigionIdHandler = (regionId, month, year) => {
    this.setState({
      regionId,
      month,
      year,
    });
  };
  onCLickPie = (event, categoryId) => {
    const { getSubCategoryNew, showLoador, showNotification } = this.props;
    const { month, year, regionId } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getSubCategoryNew({
        year: dayjs().format("YYYY"),
        month: dayjs().format("MM"),
        categoryId: categoryId,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            popUpFlag: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onCLickPieChart = (e, packagingTypeId) => {
    const { getGroupWisePackagingType, showLoador, showNotification } =
      this.props;
    const { month, year, regionId } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getGroupWisePackagingType({
        year: dayjs().format("YYYY"),
        month: dayjs().format("MM"),
        packagingTypeId: packagingTypeId,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            popUpFlagCategory: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  onSearchForSalesTeamList = (searchValueForSalesTeamList) => {
    this.setState({
      searchValueForSalesTeamList: searchValueForSalesTeamList,
    });
  };

  onSearchForSalesTeamAnalysisList = (searchValueSalesTeamAnalysisList) => {
    this.setState({
      searchValueSalesTeamAnalysisList: searchValueSalesTeamAnalysisList,
    });
  };
  getFilteredTableDataForSalesTeamList = (searchData) => {
    const { searchValueForSalesTeamList } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["employeeCode"] &&
          currentRow["employeeCode"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["district_names"] &&
          currentRow["district_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase())) ||
        (currentRow["area_names"] &&
          currentRow["area_names"]
            .toString()
            .toLowerCase()
            .includes(searchValueForSalesTeamList.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  getFilteredTableDataForSalesTeamAnalysisList = (searchData) => {
    const { searchValueSalesTeamAnalysisList } = this.state;
    const searchTerm = searchValueSalesTeamAnalysisList.trim().toLowerCase();

    if (!searchTerm) {
      return searchData;
    }

    return searchData.filter((currentRow) => {
      const searchableFields = [
        "employeeCode",
        "employeeName",
        "designation",
        "statusValue",
      ];

      return searchableFields.some(
        (field) =>
          currentRow[field] &&
          currentRow[field]
            .toString()
            .toLowerCase()
            .includes(searchTerm)
      );
    });
  };

  getSalesTeamAnalysisTabCounts = () => {
    const { backgroundSettingHistory } = this.state;
    const counts = TAB_CONFIG.reduce((acc, tab) => {
      acc[tab.flag] = 0;
      return acc;
    }, {});

    for (let i = 0; i < backgroundSettingHistory.length; i++) {
      const flag = backgroundSettingHistory[i]?.flag;
      if (counts[flag] !== undefined) {
        counts[flag] += 1;
      }
    }

    return counts;
  };

  changeDate = (name) => (date) => {
    this.setState({
      [name]: date,
    });
  };

  generateExcel = () => {
    const { showLoador, showNotification } = this.props;
    const { dateForSalesTeamList, areaIdsStore } = this.state;

    if (navigator.onLine) {
      if (
        localStorage.getItem(
          "isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash"
        ) &&
        localStorage.getItem(
          "isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash"
        ) == 1
      ) {
        if (this.checkValidationOnSalesTeamSearch()) {
          const dataToSave = {
            areaIds: areaIdsStore ? areaIdsStore : "",
            fromDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
            toDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
            flag: 7,
          };

          showLoador({ loador: true });
          downloadF({
            isGet: false,
            url:
              endpoint.adminDashboard +
              "/sales-teams-with-count-or-check-in-status-by-dates-and-flag-excel",
            postBody: dataToSave,
            ext: "xlsx",
            openNewTab: true,
          }).then((response) => {
            showLoador({ loador: false });
            if (!response) {
              this.props.showNotification({
                msg: serverMsg,
                severity: "error",
              });
            } else {
            }
          });
        }
      } else {
        if (this.checkValidationOnSalesTeamSearch()) {
          const dataToSave = {
            areaIds: areaIdsStore ? areaIdsStore : "",
          };

          showLoador({ loador: true });
          downloadF({
            isGet: false,
            url:
              endpoint.adminDashboard +
              "/get-excel-sales-teams-by-date-and-areas?fromDate=" +
              dayjs(dateForSalesTeamList).format("DD-MM-YYYY") +
              "&toDate=" +
              dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
            postBody: dataToSave,
            ext: "xlsx",
            openNewTab: true,
          }).then((response) => {
            showLoador({ loador: false });
            if (!response) {
              this.props.showNotification({
                msg: serverMsg,
                severity: "error",
              });
            } else {
            }
          });
        }
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  //comment by Ritesh
  handleChangeTabValue = (event, newValue) => {
    this.setState({
      value: newValue,
    });
  };

  handleChangeTabValueForSalesTeamAnalysis = (event, newValue) => {
    this.setState({
      valueForSalesTeamAnalysis: newValue,
    });
  };

  checkValidationOnSalesTeamSearch = () => {
    const { region, state, zone, district, taluka, area } = this.state;
    let formErrors = {};
    let formIsValid = true;

    if (
      localStorage.getItem(
        "isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash"
      ) &&
      localStorage.getItem(
        "isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash"
      ) != 1
    ) {
      if (region.length == 0 || region === null) {
        formIsValid = false;
        formErrors["regionError"] = myConstClass.regionMsg;
      }
      if (state === null || state.length == 0) {
        formIsValid = false;
        formErrors["stateError"] = myConstClass.stateMsg;
      }
      if (zone.length == 0) {
        formIsValid = false;
        formErrors["zoneError"] = myConstClass.zoneMsg;
      }
      if (district.length == 0) {
        formIsValid = false;
        formErrors["districtError"] = myConstClass.districtMsg;
      }
      if (taluka.length == 0) {
        formIsValid = false;
        formErrors["talukaError"] = myConstClass.talukaMsg;
      }
      if (area.length == 0) {
        formIsValid = false;
        formErrors["areaError"] = myConstClass.areaMsg;
      }
    }

    this.setState({
      formErrors: formErrors,
    });
    return formIsValid;
  };

  searchSalesTeamData = () => {
    const {
      getSalesTeamInfoByDatesWithAttendanceAndArea,
      getSalesTeamInfoByDatesAndFlag,
      showLoador,
      showNotification,
      myConstClass,
    } = this.props;
    const { dateForSalesTeamList, areaIdsStore } = this.state;

    const isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash =
      localStorage.getItem(
        "isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash"
      );

    if (navigator.onLine) {
      if (
        isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash &&
        isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash == 1
      ) {
        let dataJson = {
          areaIds: "",
          toDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
          fromDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
          flag: 7,
        };
        showLoador({ loador: true });
        getSalesTeamInfoByDatesAndFlag({
          dataJson,
        }).then(({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: response.serverMsg, severity: "error" });
          } else {
            let totalOutletCount = 0,
              zero = 0,
              productiveCall = 0,
              unvisited = 0,
              salesAmt = 0,
              totalAmount = 0;
            if (response.length !== 0) {
              response.map((salesTeam) => {
                totalOutletCount =
                  totalOutletCount + +salesTeam.totalOutletCount;
                productiveCall = productiveCall + +salesTeam.productiveCall;
                zero = zero + +salesTeam.zeroOrderCount;
                unvisited = unvisited + +salesTeam.unvisitedOutletCount;
                salesAmt = salesAmt + +salesTeam.totalSalesAmt;
                totalAmount = totalAmount + +salesTeam.totalAmount;
              });
            }
            this.setState({
              totalOutletCount: totalOutletCount,
              zero: zero,
              productiveCall: productiveCall,
              unvisited: unvisited,
              salesAmt: salesAmt,
              totalAmount: totalAmount,
            });
          }
        });
      } else {
        if (this.checkValidationOnSalesTeamSearch()) {
          let areaIds = {
            areaIds: areaIdsStore,
          };
          showLoador({ loador: true });
          getSalesTeamInfoByDatesWithAttendanceAndArea({
            fromDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
            toDate: dayjs(dateForSalesTeamList).format("DD-MM-YYYY"),
            areaJson: areaIds,
          }).then(({ response, success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: response.serverMsg, severity: "error" });
            } else {
              let totalOutletCount = 0,
                zero = 0,
                productiveCall = 0,
                unvisited = 0,
                salesAmt = 0,
                totalAmount = 0;
              if (response.length !== 0) {
                response.map((salesTeam) => {
                  totalOutletCount =
                    totalOutletCount + +salesTeam.totalOutletCount;
                  productiveCall = productiveCall + +salesTeam.productiveCall;
                  zero = zero + +salesTeam.zeroOrderCount;
                  unvisited = unvisited + +salesTeam.unvisitedOutletCount;
                  salesAmt = salesAmt + +salesTeam.totalSalesAmt;
                  totalAmount = totalAmount + +salesTeam.totalAmount;
                });
              }
              this.setState({
                totalOutletCount: totalOutletCount,
                zero: zero,
                productiveCall: productiveCall,
                unvisited: unvisited,
                salesAmt: salesAmt,
                totalAmount: totalAmount,
              });
            }
          });
        }
      }
    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };


  searchSalesTeamAnalysisData = async () => {
    const {
      getSalesTeamWithBackgroundTrackingDataAndHistoryByDate,
      showLoador,
      showNotification,
      myConstClass,
    } = this.props;
    const { dateForSalesTeamAnalysis } = this.state;

    if (navigator.onLine) {

      const dateToSend = dayjs(dateForSalesTeamAnalysis).format("DD-MM-YYYY");

      showLoador({ loador: true });
      await getSalesTeamWithBackgroundTrackingDataAndHistoryByDate({ date: dateToSend }).then(({ response, success }) => {
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            backgroundSettingHistory: response?.backgroundSettingHistory ? response.backgroundSettingHistory : [],
          })
        }
      });
      showLoador({ loador: false });

    } else {
      showNotification({ msg: myConstClass.noInternetMsg, severity: "error" });
    }
  };

  multiSelectHandlerForSalesTeamList = (value, name) => {
    const { region, state, zone, district, taluka, area, areaIdsStore } =
      this.state;
    const {
      regionList,
      stateList,
      zoneList,
      districtList,
      talukaList,
      areaList,
      showLoador,
      showNotification,
      getDistrictByZone,
      getTalukaByDistrictPost,
      getAreaByTalukaPostBodyUpdated,
      getZoneByState,
      getStateByRegion,
    } = this.props;

    let updatedValue = [...value];

    const isAllSelected = updatedValue.includes("all");
    if (isAllSelected) {
      let allIds = [];

      if (name === "region") {
        allIds = regionList.region.map((data) => data.id);
        this.setState({ region: ["all"] });
        showLoador({ loador: true });
        getStateByRegion({ regionIds: allIds }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) showNotification({ msg: serverMsg, severity: "error" });
        });
      } else if (name === "state") {
        allIds = stateList.stateByRegion.map((data) => data.id);
        this.setState({ state: ["all"] });
        showLoador({ loador: true });
        getZoneByState({ stateIds: allIds }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) showNotification({ msg: serverMsg, severity: "error" });
        });
      } else if (name === "zone") {
        allIds = zoneList.zoneByState.map((data) => data.id);
        this.setState({ zone: ["all"] });
        showLoador({ loador: true });
        getDistrictByZone({ zoneIds: allIds }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) showNotification({ msg: serverMsg, severity: "error" });
        });
      } else if (name === "district") {
        allIds = districtList.districtByZone.map((data) => data.id);
        this.setState({ district: ["all"] });

        let districtIdsByPost = {
          districtIds: allIds,
        };
        showLoador({ loador: true });
        getTalukaByDistrictPost({ districtIds: districtIdsByPost }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success)
              showNotification({ msg: serverMsg, severity: "error" });
          }
        );
      } else if (name === "taluka") {
        allIds = talukaList.talukaByDistrict.map((data) => data.id);
        this.setState({ taluka: ["all"] });

        let talukaIdsByPost = { talukaIds: allIds };
        showLoador({ loador: true });
        getAreaByTalukaPostBodyUpdated({ talukaIds: talukaIdsByPost }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success)
              showNotification({ msg: serverMsg, severity: "error" });
          }
        );
      } else if (name === "area") {
        allIds = areaList.areaByTaluka.map((data) => data.id);
        this.setState({ area: ["all"], areaIdsStore: allIds });
      }
    } else {
      updatedValue = updatedValue.filter((id) => id !== "all");

      if (value.length == 0) {
        this.setState({
          state: name === "region" ? [] : state,
          zone: name === "region" ? [] : name === "state" ? [] : zone,
          district:
            name === "region"
              ? []
              : name === "state"
                ? []
                : name === "zone"
                  ? []
                  : district,
          taluka:
            name === "region"
              ? []
              : name === "state"
                ? []
                : name === "zone"
                  ? []
                  : name === "district"
                    ? []
                    : taluka,
          area:
            name === "region"
              ? []
              : name === "state"
                ? []
                : name === "zone"
                  ? []
                  : name === "district"
                    ? []
                    : name === "taluka"
                      ? []
                      : area,
          areaIdsStore:
            name === "region"
              ? []
              : name === "state"
                ? []
                : name === "zone"
                  ? []
                  : name === "district"
                    ? []
                    : name === "taluka"
                      ? []
                      : areaIdsStore,
        });
      }

      if (name === "region") {
        this.setState({ region: updatedValue });
        if (updatedValue.length !== 0) {
          showLoador({ loador: true });
          getStateByRegion({ regionIds: updatedValue }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success)
              showNotification({ msg: serverMsg, severity: "error" });
          });
        }
      } else if (name === "state") {
        this.setState({ state: updatedValue });
        if (updatedValue.length !== 0) {
          showLoador({ loador: true });
          getZoneByState({ stateIds: updatedValue }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success)
              showNotification({ msg: serverMsg, severity: "error" });
          });
        }
      } else if (name === "zone") {
        this.setState({ zone: updatedValue });
        if (updatedValue.length !== 0) {
          showLoador({ loador: true });
          getDistrictByZone({ zoneIds: updatedValue }).then(({ success }) => {
            showLoador({ loador: false });
            if (!success)
              showNotification({ msg: serverMsg, severity: "error" });
          });
        }
      } else if (name === "district") {
        this.setState({ district: updatedValue });
        if (updatedValue.length !== 0) {
          let districtIdsByPost = {
            districtIds: updatedValue,
          };
          showLoador({ loador: true });
          getTalukaByDistrictPost({ districtIds: districtIdsByPost }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success)
                showNotification({ msg: serverMsg, severity: "error" });
            }
          );
        }
      } else if (name === "taluka") {
        this.setState({ taluka: updatedValue });
        if (updatedValue.length !== 0) {
          let talukaIdsByPost = { talukaIds: updatedValue };
          showLoador({ loador: true });
          getAreaByTalukaPostBodyUpdated({ talukaIds: talukaIdsByPost }).then(
            ({ success }) => {
              showLoador({ loador: false });
              if (!success)
                showNotification({ msg: serverMsg, severity: "error" });
            }
          );
        }
      } else if (name === "area") {
        this.setState({ area: updatedValue, areaIdsStore: updatedValue });
      }
    }
  };

  rowLinkOnSubCategory = (rowData) => {
    const { getGroupBySubCategory, showLoador, showNotification } = this.props;
    const { month, year, subCategoryId } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getGroupBySubCategory({
        year: dayjs().format("YYYY"),
        month: dayjs().format("MM"),
        subCategoryId: rowData.id,
      }).then(({ success, response }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            popUpFlagForSubCategory: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowLinkOnProduct = (rowData) => {
    const { getProductByGroupId, showLoador, showNotification } = this.props;
    const { month, year, subCategoryId } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getProductByGroupId({
        year: dayjs().format("YYYY"),
        month: dayjs().format("MM"),
        groupId: rowData.id,
      }).then(({ success, response }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            popUpFlagForProduct: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowLinkOnPackagingType = (rowData) => {
    const { getProductByGroupIdAndPackagingId, showLoador, showNotification } =
      this.props;
    const { month, year, subCategoryId } = this.state;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getProductByGroupIdAndPackagingId({
        year: dayjs().format("YYYY"),
        month: dayjs().format("MM"),
        groupId: rowData.id,
        packagingType: rowData.packagingTypeId,
      }).then(({ success, response }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          this.setState({
            popUpFlagForPackagingType: true,
          });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };


  getFilteredRows = () => {
    const { backgroundSettingHistory, valueForSalesTeamAnalysis } = this.state;

    const activeTab = TAB_CONFIG.find((t) => t.value == valueForSalesTeamAnalysis);

    if (!activeTab) return [];

    return backgroundSettingHistory.filter((row) => row.flag === activeTab.flag);
  };


  render() {
    const {
      dashboardData,
      billingHistoryList,
      subCategoryList,
      groupList,
      productListNew,
      stockStakeHolderTypeList,
      showNotification,
      showLoador,
      beatList,
      dashboardDataForProduct,
      regionList,
      stateList,
      zoneList,
      districtList,
      talukaList,
      areaList,
    } = this.props;
    const {
      type,
      saleMonth,
      radioValue,
      searchValueForProduct,
      lineGraphData,
      productList,
      popUpFlag,
      popUpFlagForSubCategory,
      popUpFlagForProduct,
      popUpFlagForPackagingType,
      popUpFlagCategory,
      beatPopupFlag,
      totalOutletCount,
      productiveCall,
      unvisited,
      zero,
      totalAmount,
      salesAmt,
      dateForSalesTeamList,
      dateForSalesTeamAnalysis,
      formErrors,
      salesListFromYearAndMonthOnSearch,
      value,
      region,
      state,
      zone,
      district,
      taluka,
      area,
      backgroundSettingHistory,
      valueForSalesTeamAnalysis,
      searchValueSalesTeamAnalysisList,
    } = this.state;

    const isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard =
      localStorage.getItem("isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard") ?? 0;

    const isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash =
      localStorage.getItem(
        "isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash"
      );

    const { typeError, dateError } = this.state.formErrors;
    const adminDashboard = localStorage.getItem("adminDashboard");
    const adminDashboardData = JSON.parse(adminDashboard);

    const stockStakeHolderType = localStorage.getItem("stockStakeHolderTypeId");
    const stockStakeHolderTypeListData = localStorage.getItem(
      "stockStakeHolderTypeListData"
    );
    const stockStakeHolderTypeListLocalStorage = JSON.parse(
      stockStakeHolderTypeListData
    );

    const monthYearTargetData = localStorage.getItem("monthYearTargetData");
    const monthYearTargetDataLocalStorage = JSON.parse(monthYearTargetData);

    const salesListFromYearAndMonthData = localStorage.getItem(
      "salesListFromYearAndMonthNew"
    );
    const salesListFromYearAndMonthLocalStorage = JSON.parse(
      salesListFromYearAndMonthData
    );

    const topProductListData = localStorage.getItem("topProductList");
    const topProductListDataLocalStorage = JSON.parse(topProductListData);

    const categoryWiseBillData = localStorage.getItem("categoryWiseBillData");
    const categoryWiseBillDataLocalStorage = JSON.parse(categoryWiseBillData);

    const packagingTypeData = localStorage.getItem("packagingTypeData");
    const packagingTypeDataLocalStorage = JSON.parse(packagingTypeData);

    const showPaymentValidationMsg =
      localStorage.getItem("showPaymentValidationMsg");

    const paymentMessage =
      localStorage.getItem("paymentValidationMsg") ?? "";

    const shouldShow =
      showPaymentValidationMsg !== null &&
      showPaymentValidationMsg != 0;


    const salesTeamAnalysisTabCounts = this.getSalesTeamAnalysisTabCounts();
    const filteredRows = this.getFilteredRows();
    const salesTeamAnalysisTableRows =
      this.getFilteredTableDataForSalesTeamAnalysisList(filteredRows);
    const salesTeamAnalysisColumns = getSalesTeamAnalysisColumns(
      valueForSalesTeamAnalysis
    );

    const isShowSalesTeamLocationWiseData =
      localStorage.getItem("isShowSalesTeamLocatioWiseDataAtAnalyticalDashboard") ?? 0;

    return (
      <>
        {shouldShow && (
          <SubscriptionExpiryMarquee
            message={paymentMessage}
            position="form"
          />
        )}
        <div
          id="layout-wrapper"
          style={{
            backgroundColor: "#fff",
          }}
        >
          {/* ========== App Menu ========== */}

          {/* Left Sidebar End */}
          {/* Vertical Overlay*/}
          <div className="vertical-overlay" />
          {/* ============================================================== */}
          {/* Start right Content here 
              {/* ============================================================== */}
          <div className="main-content">
            <div className="page-content">
              <div className="container-fluid">
                {/* Card 1 */}
                <div
                  style={{
                    padding: "20px 6px",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      // width: "22%",
                      flex: "1",
                      // height: "100px",
                      borderRadius: "3%",
                      padding: "12px",
                      // border:"1px solid black",
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      // boxShadow:
                      //   " rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset",
                      // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      {/* // image & cartCount */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "60px",
                          height: "60px",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "15%",
                            // backgroundColor: "lightgray",
                            backgroundImage:
                              "linear-gradient(to right, #004969 , #036e9d)",
                            position: "absolute",
                            top: "-25px",
                            left: "-4px",
                            objectFit: "contain",
                            padding: "10px",
                          }}
                          src={image4}
                          alt=""
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "25px",
                          fontWeight: "600",
                        }}
                      >
                        {ConvertAmount({
                          amount: adminDashboardData
                            ? +adminDashboardData.currentAchievedAmt
                            : "",
                        })}
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "4px 0",
                        fontWeight: "400",
                        fontSize: "15px",
                      }}
                    >
                      {" "}
                      Total Sales
                    </div>

                    <div
                      style={{
                        backgroundColor: "lightgray",
                        height: "1px",
                        width: "100%",
                      }}
                    >
                      {" "}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "8px 0",
                        fontWeight: "600",
                        fontSize: "20px",
                      }}
                    >
                      {" "}
                      TOTAL SALES
                    </div>
                  </div>
                  {/* Card 1  end*/}
                  {/* Card 2 */}
                  <div
                    style={{
                      backgroundColor: "white",
                      // width: "22%",
                      flex: "1",
                      // height: "100px",
                      borderRadius: "3%",
                      padding: "12px",
                      // border:"1px solid black",
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      // boxShadow:
                      //   " rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset",
                      // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      {/* // image & cartCount */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "60px",
                          height: "60px",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "15%",
                            // backgroundColor: "lightgray",
                            backgroundImage:
                              "linear-gradient(to right, #004969 , #036e9d)",
                            position: "absolute",
                            top: "-25px",
                            left: "-4px",
                            objectFit: "contain",
                            padding: "10px",
                          }}
                          src={image5}
                          alt=""
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "25px",
                          fontWeight: "600",
                        }}
                      >
                        {adminDashboardData
                          ? +adminDashboardData.totalOutletCount
                          : ""}
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "4px 0",
                        fontWeight: "400",
                        fontSize: "15px",
                      }}
                    >
                      {" "}
                      Total Outlet
                    </div>

                    <div
                      style={{
                        backgroundColor: "lightgray",
                        height: "1px",
                        width: "100%",
                      }}
                    >
                      {" "}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "8px 0",
                        fontWeight: "600",
                        fontSize: "20px",
                      }}
                    >
                      {" "}
                      OUTLETS
                    </div>
                  </div>
                  {/* Card 2 end */}
                  {/* Card 3 */}
                  <div
                    style={{
                      backgroundColor: "white",
                      // width: "22%",
                      flex: "1",
                      // height: "100px",
                      borderRadius: "3%",
                      padding: "12px",
                      // border:"1px solid black",
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      // boxShadow:
                      //   " rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset",
                      // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      {/* // image & cartCount */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "60px",
                          height: "60px",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "15%",
                            // backgroundColor: "lightgray",
                            backgroundImage:
                              "linear-gradient(to right, #004969 , #036e9d)",
                            position: "absolute",
                            top: "-25px",
                            left: "-4px",
                            objectFit: "contain",
                            padding: "10px",
                          }}
                          src={image7BgClr}
                          alt=""
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "25px",
                          fontWeight: "600",
                        }}
                      >
                        {adminDashboardData
                          ? +adminDashboardData.totalStakeHolderCount
                          : ""}
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "4px 0",
                        fontWeight: "400",
                        fontSize: "15px",
                      }}
                    >
                      {" "}
                      Total Stock-Holder
                    </div>

                    <div
                      style={{
                        backgroundColor: "lightgray",
                        height: "1px",
                        width: "100%",
                      }}
                    >
                      {" "}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "8px 0",
                        fontWeight: "600",
                        fontSize: "20px",
                      }}
                    >
                      {" "}
                      STOCK-HOLDERS
                    </div>
                  </div>
                  {/* Card 3 end */}
                  {/* Card 4 */}
                  <div
                    style={{
                      backgroundColor: "white",
                      // width: "22%",
                      // height: "100px",
                      flex: "1",
                      borderRadius: "3%",
                      padding: "12px",
                      // border:"1px solid black",
                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                      // boxShadow:
                      //   " rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset",
                      // boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {" "}
                      {/* // image & cartCount */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "60px",
                          height: "60px",
                          position: "relative",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "15%",
                            // backgroundColor: "lightgray",
                            backgroundImage:
                              "linear-gradient(to right, #004969 , #036e9d)",
                            position: "absolute",
                            top: "-25px",
                            left: "-4px",
                            objectFit: "contain",
                            padding: "10px",
                          }}
                          src={image6}
                          alt=""
                        />
                      </div>
                      <span
                        style={{
                          fontSize: "25px",
                          fontWeight: "600",
                        }}
                      >
                        {adminDashboardData
                          ? +adminDashboardData.totalSalesTeamCount
                          : ""}
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "4px 0",
                        fontWeight: "400",
                        fontSize: "15px",
                      }}
                    >
                      {" "}
                      Total Manpower
                    </div>

                    <div
                      style={{
                        backgroundColor: "lightgray",
                        height: "1px",
                        width: "100%",
                      }}
                    >
                      {" "}
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        padding: "8px 0",
                        fontWeight: "600",
                        fontSize: "20px",
                      }}
                    >
                      {" "}
                      MANPOWER
                    </div>
                  </div>
                  {/* Card 4 end */}
                </div>

                <div
                  className="row"
                  style={{
                    gap: 10,
                    padding: 12,
                    flexWrap: "nowrap",
                  }}
                >
                  {/* Target Card Start */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      flex: "2",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        padding: "12px",
                        borderRadius: "5%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          // alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <h1 style={{ fontWeight: "600" }}>TARGET</h1>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                          >
                            {" "}
                            <h1>
                              {" "}
                              {ConvertAmount({
                                amount: adminDashboardData
                                  ? +adminDashboardData.currentTargetAmt
                                  : "",
                              })}
                            </h1>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "60px",
                            height: "60px",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "15%",
                              backgroundImage:
                                "linear-gradient(to right, #508201 , #7ac206)",
                              objectFit: "contain",
                              padding: "10px",
                            }}
                            src={target1}
                            alt=""
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            fontWeight: "600",
                            color: "green",
                            fontSize: "22px",
                          }}
                        >
                          {ConvertAmount({
                            amount: adminDashboardData
                              ? +adminDashboardData.currentAchievedAmt
                              : "",
                          })}
                        </div>{" "}
                        <span>Achived</span>
                      </div>
                    </div>

                    {/* ///***** */}

                    <div
                      style={{
                        backgroundColor: "white",
                        display: "flex",
                        flexDirection: "column",
                        gap: "20px",
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        padding: "12px",
                        borderRadius: "5%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          // alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <h1 style={{ fontWeight: "600" }}>MONTHLY</h1>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              width: "100%",
                            }}
                          >
                            {" "}
                            <h1>
                              {" "}
                              {ConvertAmount({
                                amount: adminDashboardData
                                  ? +adminDashboardData.targetAmt
                                  : "",
                              })}
                            </h1>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "60px",
                            height: "60px",
                            position: "relative",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "15%",
                              backgroundImage:
                                "linear-gradient(to right, #508201 , #7ac206)",
                              objectFit: "contain",
                              padding: "10px",
                            }}
                            src={target1}
                            alt=""
                          />
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            fontWeight: "600",
                            color: "green",
                            fontSize: "22px",
                          }}
                        >
                          {ConvertAmount({
                            amount: adminDashboardData
                              ? +adminDashboardData.achivedAmt
                              : "",
                          })}
                        </div>{" "}
                        <span>Achived</span>
                      </div>
                    </div>
                  </div>
                  {/* Target Card Ends */}
                  {/* Bar Graph starts */}
                  <div
                    className="Group11172"
                    style={{ flex: "6", position: "relative" }}
                  >
                    <div>
                      <ReactApexChart
                        options={{
                          chart: {
                            height: 400,
                            type: "area",
                          },
                          dataLabels: {
                            enabled: false,
                          },
                          stroke: {
                            curve: "smooth",
                          },
                          xaxis: {
                            categories: [
                              "Apr",
                              "May",
                              "Jun",
                              "Jul",
                              "Aug",
                              "Sep",
                            ],
                          },
                          tooltip: {
                            theme: "light",
                          },
                        }}
                        series={[
                          {
                            name: "Target",
                            data:
                              monthYearTargetDataLocalStorage !== null
                                ? monthYearTargetDataLocalStorage[0].data
                                : [],
                          },
                          {
                            name: "Achieved",
                            data:
                              monthYearTargetDataLocalStorage !== null
                                ? monthYearTargetDataLocalStorage[1].data
                                : [],
                          },
                        ]}
                        type="area"
                        height={350}
                      />
                    </div>
                  </div>

                  {/* Bar Graph ends */}
                </div>

                {/* Sales Div starts */}

                <div
                  className="Frame427319149"
                  style={{
                    width: "100%",
                    height: 36,
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 12,
                    display: "inline-flex",
                  }}
                >
                  <div
                    className="SalesManpower"
                    style={{
                      color: "black",
                      fontSize: 24.28,
                      fontFamily: "Poppins",
                      fontWeight: "500",
                      textTransform: "capitalize",
                      wordWrap: "break-word",
                    }}
                  >
                    Sales
                  </div>
                </div>
                {/* Sales Div end */}
                <HierarchyDropDownOld rigionIdHandler={this.rigionIdHandler} />
                {/* Top 20 Div end */}
                <div
                  className="row"
                  style={{
                    gap: 8,
                    marginBottom: 10,
                    width: "100%",
                    marginLeft: 5,
                  }}
                >
                  <div
                    style={{
                      width: "56.4%",
                      background: "white",
                      padding: 5,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {/* sales Overview graph starts */}
                    <div
                      // className="card"
                      style={{
                        marginBottom: -2,
                        background: "white",
                        borderRadius: 8,
                        border: "0 #E6E6E6 solid",
                      }}
                    >
                      <div
                        className="card-header align-items-center d-flex"
                        style={{
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                          overflow: "scroll",
                        }}
                      >
                        <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                          Top Performing Product
                          <div
                            style={{
                              marginLeft: -25,
                            }}
                          >
                            <SearchBar
                              placeHolder="Search..."
                              inputProps={{ "aria-label": "search" }}
                              searchValueForProduct={searchValueForProduct}
                              filteredRows={
                                this.onSearchForTopPerformingProducts
                              }
                            ></SearchBar>
                          </div>
                        </h4>
                        <h4
                          className="text-uppercase card-title mb-0 flex-grow-1"
                          style={{
                            textAlign: "end",
                            width: 180,
                          }}
                        >
                          <MonthCalender
                            title=""
                            name="saleMonth"
                            value={saleMonth}
                            onChange={this.onDateChange}
                            sx={{
                              paddingBottom: 0,
                            }}
                          />
                        </h4>
                      </div>
                    </div>
                    <TableContainer
                      sx={{
                        maxHeight: 440,
                        marginTop: 0,
                        // width: "60%",
                        // padding: 1.5,
                      }}
                    >
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead
                          style={{
                            backgroundColor: "#fff",
                          }}
                        >
                          <TableRow>
                            <TableCell align="center" sx={{ width: "2%" }}>
                              Sr.No
                            </TableCell>
                            <TableCell align="center" sx={{ width: "8%" }}>
                              Name
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              Product Code
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              Acheived
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              % Contribution
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {topProductListDataLocalStorage &&
                            topProductListDataLocalStorage.length !== 0 &&
                            topProductListDataLocalStorage.map(
                              (productObject, index) => {
                                let finalTotal =
                                  topProductListDataLocalStorage.reduce(
                                    (total, obj) => total + +obj.orderVale,
                                    0
                                  );
                                let contribution = (
                                  (+productObject.orderVale / finalTotal) *
                                  100
                                ).toFixed();
                                return (
                                  <TableRow key={index}>
                                    <TableCell align="center">
                                      {index + 1}
                                    </TableCell>
                                    <TableCell width="2%">
                                      <div
                                        onClick={(e) =>
                                          this.topProductHandler(
                                            e,
                                            productObject.id
                                          )
                                        }
                                        style={{
                                          color: cyanBlue,
                                          cursor: "pointer",
                                        }}
                                      >
                                        {productObject.name}
                                      </div>
                                    </TableCell>
                                    <TableCell align="center">
                                      {productObject.code}
                                    </TableCell>
                                    <TableCell align="right">
                                      {productObject.orderVale}
                                    </TableCell>
                                    <TableCell align="right">
                                      {contribution}
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Sales & Manpower Table 1 end */}
                  </div>

                  <div
                    style={{
                      width: "40%",
                      background: "white",
                      padding: 5,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {/* Sales & Manpower Table 2 starts */}
                    {productList !== 0 ? (
                      <MonthlyBarChart
                        height={550}
                        series={[
                          {
                            name: "Product Sale",
                            data: productList.map((product) =>
                              product.totalAmount !== null
                                ? product.totalAmount
                                : 0
                            ),
                          },
                        ]}
                        optionsObj={{
                          chart: {
                            type: "bar",
                            height: 365,
                            events: {
                              dataPointSelection: (
                                event,
                                chartContext,
                                config
                              ) => {
                                config.dataPointIndex;
                              },
                            },
                          },
                          plotOptions: {
                            bar: {
                              columnWidth: "40%",
                              distributed: true,
                            },
                          },
                          stroke: {
                            show: true,
                            width: 2,
                          },
                          dataLabels: {
                            enabled: false,
                          },
                          xaxis: {
                            categories: productList.map((product) =>
                              product.monthYear !== null
                                ? product.monthYear
                                : ""
                            ),
                          },
                          yaxis: {
                            title: {
                              text: "Total Amount (â‚¹)",
                            },
                          },
                          fill: {
                            opacity: 1,
                          },
                          colors: [
                            "#FF0000",
                            "#00FFFF",
                            "#008000",
                            "#000FFF",
                            "#ffff33",
                            "#db4dff",
                          ],
                          tooltip: {
                            theme: "light",
                          },
                        }}
                      />
                    ) : (
                      <NoDataFound />
                    )}

                    {/* Sales & Manpower Table 2 end */}
                  </div>
                </div>
                {/* Top 20 Div starts */}
                {/* Top 20 Div end */}
                <div
                  className="row"
                  style={{
                    gap: 8,
                    marginBottom: 10,
                    width: "100%",
                    marginLeft: 5,
                  }}
                >
                  <div
                    style={{
                      width: "45%",
                      background: "white",
                      padding: 10,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {/* Distributed gragh 2 starts */}
                    <Grid item xs={12} md={4} lg={4}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Grid item>
                          <Typography variant="h5">
                            Category-Wise Sale
                          </Typography>
                        </Grid>
                      </Grid>

                      <Box sx={{ pt: 1, pr: 2 }}>
                        {categoryWiseBillDataLocalStorage &&
                          categoryWiseBillDataLocalStorage.length !== 0 ? (
                          <PieChart
                            series={categoryWiseBillDataLocalStorage.map(
                              (category) =>
                                category.totalAmt != null
                                  ? category.totalAmt
                                  : 0
                            )}
                            width={550}
                            options={{
                              chart: {
                                height: "100%",
                                width: "600%",
                                type: "donut",
                                events: {
                                  dataPointSelection: (
                                    event,
                                    chartContext,
                                    config
                                  ) => {
                                    const categoryId =
                                      categoryWiseBillDataLocalStorage[
                                        config.dataPointIndex
                                      ]?.categoryId;
                                    this.onCLickPie(event, categoryId);
                                  },
                                },
                              },
                              animations: {
                                enabled: true,
                                easing: "easeinout",
                                speed: 1000,
                                animateGradually: {
                                  enabled: true,
                                  delay: 150,
                                },
                                dynamicAnimation: {
                                  enabled: true,
                                  speed: 100,
                                },
                              },
                              labels: categoryWiseBillDataLocalStorage.map(
                                (category) => {
                                  return category.category != null
                                    ? category.category
                                    : "";
                                }
                              ),
                              responsive: [
                                {
                                  breakpoint: 480,
                                  options: {
                                    chart: {
                                      width: 600,
                                    },
                                    legend: {
                                      position: "bottom",
                                    },
                                  },
                                },
                              ],
                            }}
                          />
                        ) : (
                          <NoDataFound />
                        )}
                        {popUpFlag && (
                          <SubCategoryPackagingTypePopup
                            open={popUpFlag}
                            handleCloses={this.handleCloses}
                            columns={[
                              {
                                title: "Sr. No.",
                                name: "index",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                                canSearch: true,
                              },
                              {
                                title: "Subcategory Name",
                                name: "subCategory",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "left",
                                canSearch: true,
                                linkFlag: true,
                              },

                              {
                                title: "Total Amount",
                                name: "totalAmt",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "right",
                                canSearch: true,
                              },
                            ]}
                            rows={subCategoryList?.packagingType}
                            rowLink={this.rowLinkOnSubCategory}
                          />
                        )}
                      </Box>
                    </Grid>

                    {popUpFlagForSubCategory && (
                      <BootstrapDialog
                        onClose={this.handleClose}
                        aria-labelledby="customized-dialog-title"
                        open={open}
                        fullWidth
                        maxWidth="lg"
                      >
                        <BootstrapDialogTitle
                          id="customized-dialog-title"
                          onClose={this.handleClose}
                        >
                          Group
                        </BootstrapDialogTitle>
                        <DialogContent dividers>
                          <DynamicTable
                            data={groupList?.groupCategory}
                            tableHead={[
                              {
                                name: "index",
                                title: "Sr.No",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                                canSearch: true,
                              },

                              {
                                name: "group",
                                title: "Group Name",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "left",
                                canSearch: true,
                                linkFlag: true,
                              },

                              {
                                name: "totalAmt",
                                title: "Total Amount",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "right",
                                canSearch: true,
                              },
                            ]}
                            showPegination={false}
                            isActionColActive={false}
                            rowLink={this.rowLinkOnProduct}
                          />
                          <br />
                        </DialogContent>
                      </BootstrapDialog>
                    )}

                    {popUpFlagForProduct && (
                      <BootstrapDialog
                        onClose={this.handleCloseForProduct}
                        aria-labelledby="customized-dialog-title"
                        open={open}
                        fullWidth
                        maxWidth="lg"
                      >
                        <BootstrapDialogTitle
                          id="customized-dialog-title"
                          onClose={this.handleCloseForProduct}
                        >
                          Products
                        </BootstrapDialogTitle>
                        <DialogContent dividers>
                          <DynamicTable
                            data={productListNew?.allProduct}
                            tableHead={[
                              {
                                name: "index",
                                title: "Sr.No",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                                canSearch: true,
                              },

                              {
                                name: "name",
                                title: "Product Name",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "left",
                                canSearch: true,
                              },

                              {
                                name: "totalAmt",
                                title: "Total Amount",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "right",
                                canSearch: true,
                              },
                            ]}
                            showPegination={false}
                            isActionColActive={false}
                          />
                          <br />
                        </DialogContent>
                      </BootstrapDialog>
                    )}

                    {/* Distributed gragh 2 end */}
                  </div>

                  <div
                    style={{
                      width: "45%",
                      background: "white",
                      padding: 10,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {/* Distributed gragh 2 starts */}

                    <Grid item xs={12} md={4} lg={4}>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Grid item>
                          <Typography variant="h5">
                            Packaging-Type-Wise Sale
                          </Typography>
                        </Grid>
                      </Grid>

                      <Box sx={{ pt: 1, pr: 2 }}>
                        {packagingTypeDataLocalStorage &&
                          packagingTypeDataLocalStorage != 0 ? (
                          <PieChart
                            series={packagingTypeDataLocalStorage.map(
                              (packagingType) => {
                                return packagingType.packagingType != null
                                  ? packagingType.totalAmt
                                  : "";
                              }
                            )}
                            width={525}
                            options={{
                              chart: {
                                height: "30%",
                                width: "100%",
                                type: "donut",
                                events: {
                                  dataPointSelection: (
                                    event,
                                    chartContext,
                                    config
                                  ) => {
                                    const pacakingTypeId =
                                      packagingTypeDataLocalStorage[
                                        config.dataPointIndex
                                      ]?.packagingTypeId;
                                    this.onCLickPieChart(event, pacakingTypeId);
                                  },
                                },
                              },
                              animations: {
                                enabled: true,
                                easing: "easeinout",
                                speed: 1000,
                                animateGradually: {
                                  enabled: true,
                                  delay: 150,
                                },
                                dynamicAnimation: {
                                  enabled: true,
                                  speed: 100,
                                },
                              },
                              labels: packagingTypeDataLocalStorage.map(
                                (packagingType) => {
                                  return packagingType.packagingType != null
                                    ? packagingType.packagingType
                                    : "";
                                }
                              ),
                              responsive: [
                                {
                                  breakpoint: 480,
                                  options: {
                                    chart: {
                                      width: 600,
                                    },
                                    legend: {
                                      position: "bottom",
                                    },
                                  },
                                },
                              ],
                            }}
                          />
                        ) : (
                          <NoDataFound />
                        )}
                        {popUpFlagCategory && (
                          <CategoryPopup
                            open={popUpFlagCategory}
                            handleCloses={this.handleClosesCategory}
                            columns={[
                              {
                                title: "Sr. No.",
                                name: "index",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                                canSearch: true,
                              },

                              {
                                title: "Group Name",
                                name: "groupName",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "left",
                                canSearch: true,
                                linkFlag: true,
                              },
                              {
                                title: "Packaging Type Name",
                                name: "name",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "center",
                                canSearch: true,
                              },
                              {
                                title: "Total Amount",
                                name: "totalAmt",
                                positionCenter: false,
                                showInscreen: true,
                                alignCenter: "right",
                                canSearch: true,
                              },
                            ]}
                            rows={groupList?.groupWisePackaging}
                            rowLink={this.rowLinkOnPackagingType}
                          />
                        )}

                        {popUpFlagForPackagingType && (
                          <BootstrapDialog
                            onClose={this.handleCloseForPackagingType}
                            aria-labelledby="customized-dialog-title"
                            open={open}
                            fullWidth
                            maxWidth="lg"
                          >
                            <BootstrapDialogTitle
                              id="customized-dialog-title"
                              onClose={this.handleCloseForPackagingType}
                            >
                              Products
                            </BootstrapDialogTitle>
                            <DialogContent dividers>
                              <DynamicTable
                                data={productListNew?.allProductNew}
                                tableHead={[
                                  {
                                    name: "index",
                                    title: "Sr.No",
                                    positionCenter: false,
                                    showInscreen: true,
                                    alignCenter: "center",
                                    canSearch: true,
                                  },

                                  {
                                    name: "name",
                                    title: "Product Name",
                                    positionCenter: false,
                                    showInscreen: true,
                                    alignCenter: "center",
                                    canSearch: true,
                                  },
                                  {
                                    name: "packagingType",
                                    title: "Packaging Type",
                                    positionCenter: false,
                                    showInscreen: true,
                                    alignCenter: "center",
                                    canSearch: true,
                                  },
                                  {
                                    name: "totalAmt",
                                    title: "Total Amount",
                                    positionCenter: false,
                                    showInscreen: true,
                                    alignCenter: "right",
                                    canSearch: true,
                                  },
                                ]}
                                showPegination={false}
                                isActionColActive={false}
                              />
                              <br />
                            </DialogContent>
                          </BootstrapDialog>
                        )}
                      </Box>
                    </Grid>
                    {/* Distributed gragh 2 end */}
                  </div>
                </div>
                <div
                  className="row"
                  style={{
                    gap: 8,
                    marginBottom: 10,
                  }}
                >
                  <div
                    style={{
                      width: "62%",
                      background: "white",
                      padding: 5,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {/* Sales & Manpower Table 1 starts */}
                    <div
                      // className="card"
                      style={{
                        marginBottom: -2,
                        background: "white",
                        borderRadius: 8,
                        border: "0 #E6E6E6 solid",
                      }}
                    >
                      <div
                        className="card-header align-items-center d-flex"
                        style={{
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                          overflow: "scroll",
                          gap: "24px", // Add gap between children
                        }}
                      >
                        <h4 className="text-uppercase card-title mb-0 flex-grow-1">
                          Person Wise Sales
                          <div style={{ marginLeft: -25 }}>
                            {/* <SearchBar ... /> */}
                          </div>
                        </h4>

                        <h4
                          className="text-uppercase card-title mb-0 flex-grow-1"
                          style={{
                            marginTop: 2,
                            marginBottom: 0,
                          }}
                        >
                          <NewMultipleSelect
                            er={
                              formErrors["productMultipleError"]
                                ? formErrors["productMultipleError"]
                                : ""
                            }
                            label={"Select Stock Holder Type"}
                            name1="type"
                            value1={type}
                            names={[
                              { id: "all", name: "All" },
                              ...(stockStakeHolderTypeListLocalStorage
                                ? stockStakeHolderTypeListLocalStorage
                                : []),
                            ]}
                            onChange={this.multiSelectHandler}
                          />
                        </h4>

                        <h4
                          className="text-uppercase card-title mb-0 flex-grow-1"
                          style={{
                            textAlign: "end",
                            width: 180,
                            marginBottom: 0,
                          }}
                        >
                          <MonthCalender
                            title=""
                            name="saleMonth"
                            value={saleMonth}
                            onChange={this.onDateChange}
                            sx={{
                              paddingBottom: 0,
                            }}
                          />
                        </h4>
                      </div>
                    </div>
                    <TableContainer
                      sx={{
                        maxHeight: 440,
                        marginTop: 0,
                        // width: "60%",
                        padding: 0,
                      }}
                    >
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead
                          style={{
                            backgroundColor: "#fff",
                          }}
                        >
                          <TableRow>
                            <TableCell align="center" sx={{ width: "2%" }}>
                              Sr.No
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              Employee Code
                            </TableCell>
                            <TableCell align="center" sx={{ width: "8%" }}>
                              Name
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              Target Amount
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              Acheived
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              % Contribution
                            </TableCell>
                            <TableCell align="center" sx={{ width: "5%" }}>
                              % count (+ve, -ve)
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {salesListFromYearAndMonthOnSearch
                            ? dashboardData?.salesListFromYearAndMonth.map(
                              (regionObject, index) => (
                                <TableRow key={index}>
                                  <TableCell align="center">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell align="center">
                                    {regionObject?.employeeCode || "-"}
                                  </TableCell>
                                  <TableCell width="2%">
                                    <div
                                      onClick={(e) =>
                                        this.salesHandler(e, regionObject.id)
                                      }
                                      style={{
                                        color: cyanBlue,
                                        cursor: "pointer",
                                      }}
                                    >
                                      {regionObject.name}
                                    </div>
                                  </TableCell>
                                  <TableCell align="right">
                                    {regionObject.targetAmt}
                                  </TableCell>
                                  <TableCell align="right">
                                    {regionObject.actualAmt}
                                  </TableCell>
                                  <TableCell align="right">
                                    {regionObject.contribution}
                                  </TableCell>
                                  <TableCell align="right">
                                    {regionObject.divisional}
                                  </TableCell>
                                </TableRow>
                              )
                            )
                            : salesListFromYearAndMonthLocalStorage &&
                              salesListFromYearAndMonthLocalStorage.length !== 0
                              ? salesListFromYearAndMonthLocalStorage.map(
                                (regionObject, index) => (
                                  <TableRow key={index}>
                                    <TableCell align="center">
                                      {index + 1}
                                    </TableCell>
                                    <TableCell width="2%">
                                      <div
                                        onClick={(e) =>
                                          this.salesHandler(e, regionObject.id)
                                        }
                                        style={{
                                          color: cyanBlue,
                                          cursor: "pointer",
                                        }}
                                      >
                                        {regionObject.name}
                                      </div>
                                    </TableCell>
                                    <TableCell align="right">
                                      {regionObject.targetAmt}
                                    </TableCell>
                                    <TableCell align="right">
                                      {regionObject.actualAmt}
                                    </TableCell>
                                    <TableCell align="right">
                                      {regionObject.contribution}
                                    </TableCell>
                                    <TableCell align="right">
                                      {regionObject.divisional}
                                    </TableCell>
                                  </TableRow>
                                )
                              )
                              : null}
                          <TableRow>
                            <TableCell align="center" width="2%" colSpan={4}>
                              Total
                            </TableCell>
                            <TableCell align="right">
                              {dashboardData.salesListFromYearAndMonthTotal}
                            </TableCell>
                            <TableCell align="center">-</TableCell>
                            <TableCell align="center">-</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Sales & Manpower Table 1 end */}
                  </div>

                  <div
                    style={{
                      width: "500px",
                      background: "white",
                      padding: 5,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {/* Sales & Manpower Table 2 starts */}
                    <MonthlyBarChart
                      // radioValue={onChangeRadioValue}
                      height={550}
                      type={"line"}
                      series={[
                        {
                          name: "Achived Amount",
                          data: lineGraphData,
                        },
                      ]}
                      optionsObj={{
                        chart: {
                          height: 350,
                          type: "line",
                          zoom: {
                            enabled: false,
                          },
                        },
                        dataLabels: {
                          enabled: false,
                        },
                        stroke: {
                          curve: "straight",
                        },
                        title: {
                          text: "Performance",
                          align: "left",
                        },
                        grid: {
                          row: {
                            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                            opacity: 0.5,
                          },
                        },
                        xaxis: {
                          categories: [
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec",
                            "Jan",
                            "Feb",
                            "Mar",
                          ],
                        },
                      }}
                    />

                    {/* Sales & Manpower Table 2 end */}
                  </div>
                </div>

                <div
                  className="row"
                  style={{
                    gap: 8,
                    marginBottom: 10,
                    width: "100%",
                    marginLeft: 5,
                  }}
                >
                  <div
                    style={{
                      width: "97%",
                      background: "white",
                      padding: 5,
                      borderRadius: 8,
                      border: "1px #E6E6E6 solid",
                    }}
                  >
                    {isShowDateFilterOnlyOnSalesTeamAtAnalyticalAdminDash ==
                      0 ? (
                      <div
                        // className="card"
                        style={{
                          marginBottom: -2,
                          background: "white",
                          borderRadius: 8,
                          border: "0 #E6E6E6 solid",
                        }}
                      >
                        <div
                          style={{
                            marginLeft: 0,
                          }}
                        >
                          <h4
                            className="text-uppercase card-title mb-0 flex-grow-1"
                            style={{}}
                          >
                            Sales Team List
                          </h4>
                        </div>

                        <div
                          className="card-header align-items-center d-flex"
                          style={{
                            background: "white",
                            borderRadius: 8,
                            border: "0 #E6E6E6 solid",
                            height: 300,

                            // marginTop: 20,
                          }}
                        >
                          <h4
                            className="text-uppercase card-title mb-0 flex-grow-1"
                            style={{
                              textAlign: "left",
                              width: "300px",
                            }}
                          >
                            <Grid
                              item
                              sm={12}
                              xs={12}
                              md={12}
                              lg={12}
                              container
                              justifyContent="start"
                              flexWrap={"wrap"}
                            >
                              {/* Region & State */}
                              <Grid
                                item
                                xs={12}
                                md={12}
                                container
                                spacing={2}
                                alignItems="center"
                              >
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  alignItems="center"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                        marginRight: "8px",
                                      }}
                                      label="Region:"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <NewMultipleSelect
                                      er={formErrors["regionError"] || ""}
                                      label={"Select Region"}
                                      name1="region"
                                      value1={region}
                                      names={[
                                        { id: "all", name: "All" },
                                        ...regionList.region,
                                      ]}
                                      onChange={
                                        this.multiSelectHandlerForSalesTeamList
                                      }
                                    />
                                  </Grid>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  alignItems="center"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                        marginRight: "8px",
                                      }}
                                      label="State:"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <NewMultipleSelect
                                      er={formErrors["stateError"] || ""}
                                      label={"Select State"}
                                      name1="state"
                                      value1={state}
                                      names={[
                                        { id: "all", name: "All" },
                                        ...stateList?.stateByRegion,
                                      ]}
                                      onChange={
                                        this.multiSelectHandlerForSalesTeamList
                                      }
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                              {/* Zone & District */}
                              <Grid
                                item
                                xs={12}
                                md={12}
                                container
                                spacing={2}
                                alignItems="center"
                              >
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  alignItems="center"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                        marginRight: "8px",
                                      }}
                                      label="Zone:"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <NewMultipleSelect
                                      er={formErrors["zoneError"] || ""}
                                      label={"Select Zone"}
                                      name1="zone"
                                      value1={zone}
                                      names={[
                                        { id: "all", name: "All" },
                                        ...zoneList?.zoneByState,
                                      ]}
                                      onChange={
                                        this.multiSelectHandlerForSalesTeamList
                                      }
                                    />
                                  </Grid>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  alignItems="center"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                        marginRight: "8px",
                                      }}
                                      label="District:"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <NewMultipleSelect
                                      er={formErrors["districtError"] || ""}
                                      label={"Select District"}
                                      name1="district"
                                      value1={district}
                                      names={[
                                        { id: "all", name: "All" },
                                        ...districtList?.districtByZone,
                                      ]}
                                      onChange={
                                        this.multiSelectHandlerForSalesTeamList
                                      }
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>
                              {/* Taluka & Area */}
                              <Grid
                                item
                                xs={12}
                                md={12}
                                container
                                spacing={2}
                                alignItems="center"
                              >
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  alignItems="center"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                        marginRight: "8px",
                                      }}
                                      label="Taluka:"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <NewMultipleSelect
                                      er={formErrors["talukaError"] || ""}
                                      label={"Select Taluka"}
                                      name1="taluka"
                                      value1={taluka}
                                      names={[
                                        { id: "all", name: "All" },
                                        ...talukaList?.talukaByDistrict,
                                      ]}
                                      onChange={
                                        this.multiSelectHandlerForSalesTeamList
                                      }
                                    />
                                  </Grid>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  alignItems="center"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                        marginRight: "8px",
                                      }}
                                      label="Area:"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <NewMultipleSelect
                                      er={formErrors["areaError"] || ""}
                                      label={"Select Area"}
                                      name1="area"
                                      value1={area}
                                      names={[
                                        { id: "all", name: "All" },
                                        ...areaList.areaByTaluka,
                                      ]}
                                      onChange={
                                        this.multiSelectHandlerForSalesTeamList
                                      }
                                    />
                                  </Grid>
                                </Grid>
                              </Grid>

                              {/* Date */}
                              <Grid
                                item
                                xs={12}
                                md={12}
                                container
                                spacing={2}
                                alignItems="center"
                              >
                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  alignItems="center"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={4}
                                    display="flex"
                                    alignItems="center"
                                  >
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                        marginRight: "8px",
                                      }}
                                      label="Date:"
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={8}>
                                    <BasicDatePicker
                                      color="primary"
                                      name="dateForSalesTeamList"
                                      size="small"
                                      value={dateForSalesTeamList}
                                      disabled={false}
                                      fullWidth
                                      onChange={this.changeDate(
                                        "dateForSalesTeamList"
                                      )}
                                      errorText={
                                        formErrors[
                                        "dateForSalesTeamListError"
                                        ] || ""
                                      }
                                      isError={
                                        formErrors[
                                        "dateForSalesTeamListError"
                                        ] || ""
                                      }
                                    />
                                  </Grid>
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  md={6}
                                  container
                                  justifyContent="flex-start"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    md={6}
                                    sm={12}
                                    container
                                    spacing={2}
                                    justifyContent="flex-start"
                                  >
                                    <Grid item>
                                      <ButtonCompo
                                        sx={{
                                          bgcolor: "dodgerblue",
                                          color: "#fbff00",
                                          height: "40px",
                                          width: "100px",
                                        }}
                                        size="medium"
                                        type="button"
                                        variant="contained"
                                        name={"Search"}
                                        onClick={this.searchSalesTeamData}
                                      />
                                    </Grid>
                                    <Grid item>
                                      <ButtonCompo
                                        sx={{
                                          bgcolor: "dodgerblue",
                                          color: "#fbff00",
                                          height: "40px",
                                          width: "100px",
                                        }}
                                        size="medium"
                                        type="button"
                                        variant="contained"
                                        name={"Excel"}
                                        onClick={this.generateExcel}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: "8px" }}>
                              <LandingScreenHeader
                                screenTitle={""}
                                showSearchBox={true}
                                showTable={true}
                                showFilter={false}
                                showPdfDownload={false}
                                showExcelDownload={false}
                                generateExcel={this.generateExcel}
                                onSearch={this.onSearchForSalesTeamList}
                              />
                            </Grid>
                          </h4>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div
                          style={{
                            marginBottom: -2,
                            background: "white",
                            borderRadius: 8,
                            border: "0 #E6E6E6 solid",
                          }}
                        >
                          {/* Header Row */}
                          <div
                            className="card-header align-items-center d-flex"
                            style={{
                              background: "white",
                              borderRadius: 8,
                              border: "0 #E6E6E6 solid",
                              padding: "12px 16px",
                            }}
                          >
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              {/* Left Side - Title */}
                              <Grid item>
                                <h4
                                  className="text-uppercase card-title mb-0"
                                  style={{
                                    fontWeight: "600",
                                    marginTop: "8px",
                                  }}
                                >
                                  Sales Team List
                                </h4>
                              </Grid>

                              <Grid item xs style={{ marginTop: "8px" }}>
                                <LandingScreenHeader
                                  screenTitle={""}
                                  showSearchBox={true}
                                  showTable={true}
                                  showFilter={false}
                                  showPdfDownload={false}
                                  showExcelDownload={false}
                                  generateExcel={this.generateExcel}
                                  onSearch={this.onSearchForSalesTeamList}
                                />
                              </Grid>

                              {/* Right Side - Date + Buttons in One Row */}
                              <Grid
                                item
                                container
                                spacing={2}
                                alignItems="center"
                                justifyContent="flex-end"
                                wrap="nowrap"
                                xs="auto"
                              >
                                {/* Date Label + Required Mark + Date Picker */}
                                <Grid
                                  item
                                  display="flex"
                                  alignItems="center"
                                  sx={{ gap: 3 }}
                                >
                                  <Grid item sx={{ gap: 0 }}>
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                      }}
                                      label="Date :"
                                    />
                                  </Grid>
                                  <Box sx={{ width: "150px" }}>
                                    <BasicDatePicker
                                      color="primary"
                                      name="dateForSalesTeamList"
                                      size="small"
                                      value={dateForSalesTeamList}
                                      disabled={false}
                                      fullWidth
                                      onChange={this.changeDate(
                                        "dateForSalesTeamList"
                                      )}
                                      errorText={
                                        formErrors[
                                        "dateForSalesTeamListError"
                                        ] || ""
                                      }
                                      isError={
                                        formErrors[
                                        "dateForSalesTeamListError"
                                        ] || ""
                                      }
                                    />
                                  </Box>
                                </Grid>

                                {/* Search Button */}
                                <Grid item>
                                  <ButtonCompo
                                    sx={{
                                      bgcolor: "dodgerblue",
                                      color: "#fbff00",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                    size="medium"
                                    type="button"
                                    variant="contained"
                                    name={"Search"}
                                    onClick={this.searchSalesTeamData}
                                  />
                                </Grid>

                                {/* Excel Button */}
                                <Grid item>
                                  <ButtonCompo
                                    sx={{
                                      bgcolor: "dodgerblue",
                                      color: "#fbff00",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                    size="medium"
                                    type="button"
                                    variant="contained"
                                    name={"Excel"}
                                    onClick={this.generateExcel}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </>
                    )}

                    <Tabs
                      value={value}
                      onChange={this.handleChangeTabValue}
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                      aria-label="scrollable force tabs example"
                      sx={{
                        "& .MuiTab-root": { marginRight: "15px" },
                      }}
                    >
                      <Tab
                        value="0"
                        label={
                          "All" +
                          " ( " +
                          dashboardData?.salesInfo.length +
                          " ) "
                        }
                      />
                      <Tab
                        value="1"
                        label={
                          "Present" +
                          " ( " +
                          dashboardData?.salesInfo.filter(
                            (row) => row.attendenceStatus == 1
                          ).length +
                          " ) "
                        }
                      />
                      <Tab
                        value="2"
                        label={
                          "Absent" +
                          " ( " +
                          dashboardData?.salesInfo.filter(
                            (row) => row.attendenceStatus == 0
                          ).length +
                          " ) "
                        }
                      />
                      <Tab
                        value="3"
                        label={
                          "Late" +
                          " ( " +
                          dashboardData?.salesInfo.filter(
                            (row) => row.checkInStatus == 1
                          ).length +
                          " ) "
                        }
                      />
                      <Tab
                        value="4"
                        label={
                          "On Leave" +
                          " ( " +
                          dashboardData?.salesInfo.filter(
                            (row) => row.attendenceStatus == 2
                          ).length +
                          " ) "
                        }
                      />
                    </Tabs>

                    <br />

                    <TableContainer
                      sx={{
                        maxHeight: 440,
                        // width: 610,
                        // padding: 1.5,
                        // marginTop: 2.5,
                      }}
                    >
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead
                          style={{
                            backgroundColor: "#fff",
                          }}
                        >
                          <TableRow>
                            <TableCell
                              color="#000"
                              align="center"
                              sx={{ width: "1%", color: "#000" }}
                              canSearch="true"
                            >
                              Sr.No
                            </TableCell>
                            <TableCell
                              color="#000"
                              align="center"
                              sx={{ width: "1%", color: "#000" }}
                              canSearch="true"
                            >
                              Employee Code
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ width: "7%", color: "#000" }}
                              canSearch="true"
                            >
                              Sales Team Name
                            </TableCell>

                            {localStorage.getItem(
                              "isShowSalesTeamTypeAtAnalyticalAdminDash"
                            ) &&
                              localStorage.getItem(
                                "isShowSalesTeamTypeAtAnalyticalAdminDash"
                              ) == 1 && (
                                <TableCell
                                  align="center"
                                  sx={{ width: "7%", color: "#000" }}
                                  canSearch="true"
                                >
                                  Type
                                </TableCell>
                              )}

                            {isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard == 1 && (
                              <>
                                <TableCell
                                  align="center"
                                  sx={{ width: "7%", color: "#000" }}
                                  canSearch="true"
                                >
                                  Check In
                                </TableCell>

                                <TableCell
                                  align="center"
                                  sx={{ width: "7%", color: "#000" }}
                                  canSearch="true"
                                >
                                  Check Out
                                </TableCell>

                              </>
                            )}

                            {localStorage.getItem(
                              "showAreaDistrictColumnsOnSalesTeamListDashboard"
                            ) &&
                              localStorage.getItem(
                                "showAreaDistrictColumnsOnSalesTeamListDashboard"
                              ) == 1 && (
                                <>
                                  <TableCell
                                    align="center"
                                    sx={{ width: "2%", color: "#000" }}
                                    canSearch="true"
                                  >
                                    District
                                  </TableCell>

                                  <TableCell
                                    align="center"
                                    sx={{ width: "15%", color: "#000" }}
                                    canSearch="true"
                                  >
                                    Area
                                  </TableCell>
                                </>
                              )}
                            <TableCell
                              align="center"
                              sx={{ width: "3%", color: "#000" }}
                              canSearch="true"
                            >
                              Beat Count
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ width: "3%", color: "#000" }}
                              canSearch="true"
                            >
                              Total Outlet
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ width: "3%", color: "#000" }}
                              canSearch="true"
                            >
                              Productive Call
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ width: "3%", color: "#000" }}
                              canSearch="true"
                            >
                              Unvisited Outlet
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ width: "3%", color: "#000" }}
                              canSearch="true"
                            >
                              Zero Order
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{ width: "3%", color: "#000" }}
                              canSearch="true"
                            >
                              Total Order Amount
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{ width: "3%", color: "#000" }}
                              canSearch="true"
                            >
                              Total Sales Amount
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dashboardData.salesInfo.length != 0 &&
                            this.getFilteredTableDataForSalesTeamList(
                              value == 0
                                ? dashboardData?.salesInfo
                                : value == 1
                                  ? dashboardData?.salesInfo.filter(
                                    (row) => row.attendenceStatus == 1
                                  )
                                  : value == 2
                                    ? dashboardData?.salesInfo.filter(
                                      (row) => row.attendenceStatus == 0
                                    )
                                    : value == 4
                                      ? dashboardData?.salesInfo.filter(
                                        (row) => row.attendenceStatus == 2
                                      )
                                      : dashboardData?.salesInfo.filter(
                                        (row) => row.checkInStatus == 1
                                      )
                            ).map((salesTeamObject, index) => {
                              return (
                                <TableRow>
                                  <TableCell align="center" canSearch="true">
                                    {index + 1}
                                  </TableCell>
                                  <TableCell align="center" canSearch="true">
                                    {salesTeamObject?.employeeCode || "-"}
                                  </TableCell>
                                  <TableCell width="2%" canSearch="true">
                                    <Link
                                      color={cyanBlue}
                                      component={RouterLink}
                                      to={
                                        localStorage.getItem(
                                          "showRealTimeTracking"
                                        ) &&
                                          localStorage.getItem(
                                            "showRealTimeTracking"
                                          ) == 1
                                          ? "/gmap-with-functionality/" +
                                          salesTeamObject.salesTeamId +
                                          "/" +
                                          salesTeamObject.userTypeId
                                          : "/sales/" +
                                          salesTeamObject.salesTeamId +
                                          "/" +
                                          salesTeamObject.userTypeId
                                      }
                                    >
                                      {salesTeamObject.name}
                                    </Link>
                                  </TableCell>
                                  {localStorage.getItem(
                                    "isShowSalesTeamTypeAtAnalyticalAdminDash"
                                  ) &&
                                    localStorage.getItem(
                                      "isShowSalesTeamTypeAtAnalyticalAdminDash"
                                    ) == 1 && (
                                      <TableCell width="2%" canSearch="true">
                                        {
                                          salesTeamObject.stockStakeHolderTypeName
                                        }
                                      </TableCell>
                                    )}

                                  {isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard == 1 && (
                                    <>
                                      <TableCell width="2%" align="center" canSearch="true">
                                        {salesTeamObject?.checkInTime}
                                      </TableCell>
                                      <TableCell width="2%" align="center" canSearch="true">
                                        {salesTeamObject?.checkOutTime}
                                      </TableCell>
                                    </>
                                  )}
                                  {localStorage.getItem(
                                    "showAreaDistrictColumnsOnSalesTeamListDashboard"
                                  ) &&
                                    localStorage.getItem(
                                      "showAreaDistrictColumnsOnSalesTeamListDashboard"
                                    ) == 1 && (
                                      <>
                                        <TableCell
                                          align="left"
                                          canSearch="true"
                                        >
                                          {salesTeamObject.district_names}
                                        </TableCell>

                                        <TableCell
                                          align="left"
                                          canSearch="true"
                                        >
                                          {salesTeamObject.area_names}
                                        </TableCell>
                                      </>
                                    )}
                                  <TableCell
                                    width="2%"
                                    align="right"
                                    canSearch="true"
                                  >
                                    <div
                                      onClick={(e) =>
                                        this.salesTeamHandler(
                                          e,
                                          salesTeamObject.salesTeamId
                                        )
                                      }
                                      style={{
                                        color: cyanBlue,
                                        cursor: "pointer",
                                      }}
                                    >
                                      {salesTeamObject.beatCount}
                                    </div>
                                  </TableCell>
                                  <TableCell align="right" canSearch="true">
                                    {salesTeamObject.totalOutletCount}
                                  </TableCell>
                                  <TableCell align="right" canSearch="true">
                                    {salesTeamObject.productiveCall}
                                  </TableCell>
                                  <TableCell align="right" canSearch="true">
                                    {salesTeamObject.unvisitedOutletCount}
                                  </TableCell>
                                  <TableCell align="right" canSearch="true">
                                    {salesTeamObject.zeroOrderCount}
                                  </TableCell>
                                  <TableCell align="right" canSearch="true">
                                    {salesTeamObject.totalAmount}
                                  </TableCell>
                                  <TableCell align="right" canSearch="true">
                                    {salesTeamObject.totalSalesAmt}
                                  </TableCell>
                                </TableRow>
                              );
                            })}

                          <TableRow>
                            {localStorage.getItem(
                              "showAreaDistrictColumnsOnSalesTeamListDashboard"
                            ) == 1 ? (
                              <TableCell align="right" width="2%" colSpan={5}>
                                Total
                              </TableCell>
                            ) : localStorage.getItem(
                              "isShowSalesTeamTypeAtAnalyticalAdminDash"
                            ) == 1 ? (
                              <TableCell align="right" width="2%" colSpan={isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard == 1 ? 7 : 5}>
                                Total
                              </TableCell>
                            ) : (
                              <TableCell align="right" width="2%" colSpan={isShowSalesTeamCheckInOutTimeAtSalesTeamListDashboard == 1 ? 7 : 4}>
                                Total
                              </TableCell>
                            )}
                            <TableCell align="right">
                              {totalOutletCount}
                            </TableCell>
                            <TableCell align="right">
                              {productiveCall}
                            </TableCell>
                            <TableCell align="right">{unvisited}</TableCell>
                            <TableCell align="right">{zero}</TableCell>
                            <TableCell align="right">
                              {totalAmount.toFixed(2)}
                            </TableCell>
                            <TableCell align="right">
                              {salesAmt.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {beatPopupFlag && (
                      <BeatPopUp
                        open={beatPopupFlag}
                        handleCloses={this.handleClosesSalesTeam}
                        columns={[
                          {
                            title: "Sr. No.",
                            name: "index",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "center",
                            canSearch: true,
                          },
                          {
                            title: "Beat",
                            name: "beatName",
                            positionCenter: false,
                            showInscreen: true,
                            alignCenter: "left",
                            canSearch: true,
                          },
                        ]}
                        rows={beatList?.beatFromSalesTeamId}
                      />
                    )}
                  </div>
                </div>

                {/* Sales Team analysis*/}
                {isShowSalesTeamLocationWiseData == 1 && (
                  <div
                    className="row"
                    style={{
                      gap: 8,
                      marginBottom: 10,
                      marginTop: 20,
                      width: "100%",
                      marginLeft: 5,
                    }}
                  >
                    <div
                      style={{
                        width: "97%",
                        background: "white",
                        padding: 5,
                        borderRadius: 8,
                        border: "1px #E6E6E6 solid",
                      }}
                    >
                      {<>
                        <div
                          style={{
                            marginBottom: -2,
                            background: "white",
                            borderRadius: 8,
                            border: "0 #E6E6E6 solid",
                          }}
                        >
                          {/* Header Row */}
                          <div
                            className="card-header align-items-center d-flex"
                            style={{
                              background: "white",
                              borderRadius: 8,
                              border: "0 #E6E6E6 solid",
                              padding: "12px 16px",
                            }}
                          >
                            <Grid
                              container
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              {/* Left Side - Title */}
                              <Grid item>
                                <h4
                                  className="text-uppercase card-title mb-0"
                                  style={{
                                    fontWeight: "600",
                                    marginTop: "8px",
                                  }}
                                >
                                  Field Location Monitoring
                                </h4>
                              </Grid>

                              <Grid item xs style={{ marginTop: "8px" }}>
                                <LandingScreenHeader
                                  screenTitle={""}
                                  showSearchBox={true}
                                  showTable={true}
                                  showFilter={false}
                                  showPdfDownload={false}
                                  showExcelDownload={false}
                                  generateExcel={this.generateExcel}
                                  onSearch={this.onSearchForSalesTeamAnalysisList}
                                />
                              </Grid>

                              {/* Right Side - Date + Buttons in One Row */}
                              <Grid
                                item
                                container
                                spacing={2}
                                alignItems="center"
                                justifyContent="flex-end"
                                wrap="nowrap"
                                xs="auto"
                              >
                                {/* Date Label + Required Mark + Date Picker */}
                                <Grid
                                  item
                                  display="flex"
                                  alignItems="center"
                                  sx={{ gap: 3 }}
                                >
                                  <Grid item sx={{ gap: 0 }}>
                                    <LabelCompo
                                      style={{ fontSize: 16, color: redColor }}
                                      label="* "
                                    />
                                    <LabelCompo
                                      style={{
                                        fontSize: 16,
                                        color: titleColor,
                                      }}
                                      label="Date :"
                                    />
                                  </Grid>
                                  <Box sx={{ width: "150px" }}>
                                    <BasicDatePicker
                                      color="primary"
                                      name="dateForSalesTeamAnalysis"
                                      size="small"
                                      value={dateForSalesTeamAnalysis}
                                      disabled={false}
                                      fullWidth
                                      onChange={this.changeDate(
                                        "dateForSalesTeamAnalysis"
                                      )}
                                      errorText={
                                        formErrors[
                                        "dateForSalesTeamListError"
                                        ] || ""
                                      }
                                      isError={
                                        formErrors[
                                        "dateForSalesTeamListError"
                                        ] || ""
                                      }
                                    />
                                  </Box>
                                </Grid>

                                {/* Search Button */}
                                <Grid item>
                                  <ButtonCompo
                                    sx={{
                                      bgcolor: "dodgerblue",
                                      color: "#fbff00",
                                      height: "40px",
                                      width: "100px",
                                    }}
                                    size="medium"
                                    type="button"
                                    variant="contained"
                                    name={"Search"}
                                    onClick={this.searchSalesTeamAnalysisData}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </div>
                        </div>
                      </>}

                      <Tabs
                        value={valueForSalesTeamAnalysis}
                        onChange={this.handleChangeTabValueForSalesTeamAnalysis}
                        variant="scrollable"
                        scrollButtons
                        allowScrollButtonsMobile
                        aria-label="sales team analysis tabs"
                        sx={{ "& .MuiTab-root": { marginRight: "15px" } }}
                      >
                        {TAB_CONFIG.map((tab) => (
                          <Tab
                            key={tab.value}
                            value={tab.value}
                            label={`${tab.label} ( ${salesTeamAnalysisTabCounts[tab.flag] || 0} )`}
                          />
                        ))}
                      </Tabs>

                      <br />

                      <PaginatedDataTable
                        columns={salesTeamAnalysisColumns}
                        rows={salesTeamAnalysisTableRows}
                        getRowKey={(row, index) =>
                          row?.id ?? `${row?.employeeCode || "row"}-${index}`
                        }
                        resetKey={`${valueForSalesTeamAnalysis}-${searchValueSalesTeamAnalysisList}`}
                        tableAriaLabel="sales team analysis table"
                        defaultRowsPerPage={50}
                        rowsPerPageOptions={[25, 50, 100, 250]}
                      />
                    </div>
                  </div>
                )}

              </div>

              {/* Sales & Manpower Div end */}

              <footer className="footer">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-6">2022 Â© Byte Elephants. </div>
                    <div className="col-sm-6">
                      <div className="text-sm-end d-none d-sm-block">
                        {" "}
                        Designed &amp; Developed by Byte Elephants Technologies
                        PVT LTD{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
          </div>
        </div >
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
  dashboardData: state.adminDashboard,
  stockStakeHolderTypeList: state.stockStakeHolderType,
  zoneList: state.zone,
  areaList: state.area,
  dashboardDetails: state.dashboard,
  billingHistoryList: state.billingHistory,
  subCategoryList: state.subCategory,
  beatList: state.beat,
  regionList: state.region,
  stateList: state.states,
  districtList: state.district,
  talukaList: state.taluka,
  groupList: state.groupProduct,
  productListNew: state.product,
});

const mapDispatchToProps = {
  onToggle,
  showLoador,
  showNotification,
  getRegionListFromYearAndMonth,
  getZoneListFromYearAndMonth,
  getStockStakeHolderType,
  getSalesListFromYearAndMonthNew,
  getMonthYearTarget,
  getMonthYearTargetForSales,
  setRegionListFromYearAndMonth,
  getSalesGraph,
  getZoneStatewiseListFromYearAndMonth,
  getStateRegionwiseListFromYearAndMonth,
  getAdminDashboard,
  getCategorywiseBill,
  getSalesTeamInfoByDatesWithAttendanceAndArea,
  getPackagingType,
  getSubCategoryPackagingType,
  getCategoryByPackagingType,
  getTopProductOrderListFromYearAndMonthBillWise,
  getBeatFromSalesTeamId,
  getDistrictListFromYearAndMonth,
  getTalukaListFromYearAndMonth,
  getTopProductForAdminDashboard,
  getRegionNew,
  getStateByRegion,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrictPost,
  getAreaByTalukaPostBodyUpdated,
  setSalesListFromYearAndMonthNew,
  getSubCategoryNew,
  getGroupBySubCategory,
  getProductByGroupId,
  getGroupWisePackagingType,
  getProductByGroupIdAndPackagingId,
  getSalesTeamInfoByDatesAndFlag,
  getSalesTeamWithBackgroundTrackingDataAndHistoryByDate,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalyticalAdminDashboard);
